"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8621],{

/***/ 93837:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

const currency = {
  'pt-br': 'BRL',
  'en-US': 'USD'
};

const currencyFormatter = ({
  value = '',
  locale = 'pt-br',
  rightFilling = false,
  decimal = true
}) => new Intl.NumberFormat(locale, {
  style: 'currency',
  currency: currency[locale],
  minimumFractionDigits: decimal ? 2 : 0,
  maximumFractionDigits: decimal ? 2 : 0
}).format(rightFilling ? parseFloat(value / 100) : value);

/* harmony default export */ __webpack_exports__["Z"] = (currencyFormatter);

/***/ }),

/***/ 41544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_formatDateDistance; }
});

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/formatDateDistance/locateText.js
const dateDistanceLocale = {
  lessThanXSeconds: {
    one: 'menos de um segundo',
    other: 'menos de {{count}} segundos'
  },
  xSeconds: {
    one: '1 segundo',
    other: '{{count}} segundos'
  },
  halfAMinute: 'meio minuto',
  lessThanXMinutes: {
    one: 'menos de um minuto',
    other: 'menos de {{count}} minutos'
  },
  xMinutes: {
    one: '1 minuto',
    other: '{{count}} minutos'
  },
  aboutXHours: {
    one: 'cerca de 1 hora',
    other: 'cerca de {{count}} horas'
  },
  xHours: {
    one: '1 hora',
    other: '{{count}} horas'
  },
  xDays: {
    one: '1 dia',
    other: '{{count}} dias'
  },
  aboutXWeeks: {
    one: 'cerca de 1 semana',
    other: 'cerca de {{count}} semanas'
  },
  xWeeks: {
    one: '1 semana',
    other: '{{count}} semanas'
  },
  aboutXMonths: {
    one: 'cerca de 1 mês',
    other: 'cerca de {{count}} meses'
  },
  xMonths: {
    one: '1 mês',
    other: '{{count}} meses'
  },
  aboutXYears: {
    one: 'cerca de 1 ano',
    other: 'cerca de {{count}} anos'
  },
  xYears: {
    one: '1 ano',
    other: '{{count}} anos'
  },
  overXYears: {
    one: 'mais de 1 ano',
    other: 'mais de {{count}} anos'
  },
  almostXYears: {
    one: 'quase 1 ano',
    other: 'quase {{count}} anos'
  }
};
function getDateString(token, count) {
  let result;

  if (typeof dateDistanceLocale[token] === 'string') {
    result = dateDistanceLocale[token];
  } else if (count === 1) {
    result = dateDistanceLocale[token].one;
  } else {
    result = dateDistanceLocale[token].other.replace('{{count}}', count);
  }

  return `${result}`;
}
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/formatDateDistance/index.js

const MINUTES_IN_DAY = 1440;
const MINUTES_IN_ALMOST_TWO_DAYS = 2520;
const MINUTES_IN_MONTH = 43200;
const MINUTES_IN_TWO_MONTHS = 86400;

const formatDateDistance = (date, baseDate) => {
  const minutes = parseInt(Math.abs(new Date(date) - new Date(baseDate)) / (1000 * 60), 10);
  const seconds = Math.abs((new Date(date) - new Date(baseDate)) / 1000);
  const months = Math.abs(date.getMonth() - baseDate.getMonth() + 12 * (date.getFullYear() - baseDate.getFullYear())); // 0 up to 2 mins

  if (minutes < 2) {
    if (seconds < 40) {
      return getDateString('halfAMinute', null);
    }

    if (seconds < 60) {
      return getDateString('lessThanXMinutes', 1);
    }

    return getDateString('xMinutes', minutes);
  } // 2 mins up to 0.75 hrs


  if (minutes < 45) {
    return getDateString('xMinutes', minutes);
  } // 0.75 hrs up to 1.5 hrs


  if (minutes < 90) {
    return getDateString('aboutXHours', 1);
  } // 1 day up to 1.75 days


  if (minutes < MINUTES_IN_DAY) {
    const hours = Math.round(minutes / 60);
    return getDateString('aboutXHours', hours);
  }

  if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
    return getDateString('xDays', 1);
  } // 1.75 days up to 30 days


  if (minutes < MINUTES_IN_MONTH) {
    const days = Math.round(minutes / MINUTES_IN_DAY);
    return getDateString('xDays', days);
  } // 1 month up to 2 months


  if (minutes < MINUTES_IN_TWO_MONTHS) {
    const month = Math.round(minutes / MINUTES_IN_MONTH);
    return getDateString('aboutXMonths', month);
  } // 2 months up to 12 months


  if (months < 12) {
    const nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
    return getDateString('xMonths', nearestMonth);
  } // 1 year up to max Date


  const monthsSinceStartOfYear = months % 12;
  const years = Math.floor(months / 12); // N years up to 1 years 3 months

  if (monthsSinceStartOfYear < 3) {
    return getDateString('aboutXYears', years); // N years 3 months up to N years 9 months
  }

  if (monthsSinceStartOfYear < 9) {
    return getDateString('overXYears', years); // N years 9 months up to N year 12 months
  }

  return getDateString('almostXYears', years + 1);
};

/* harmony default export */ var esm_formatDateDistance = (formatDateDistance);

/***/ }),

/***/ 71180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jL": function() { return /* reexport safe */ _formatDateDistance__WEBPACK_IMPORTED_MODULE_1__.Z; },
/* harmony export */   "oB": function() { return /* reexport safe */ _currencyFormatter__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _currencyFormatter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93837);
/* harmony import */ var _formatDateDistance__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41544);





/***/ }),

/***/ 8719:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

const scrollToTop = (duration = 300) => {
  const step = -window.scrollY / (duration / 15);
  const scrollInterval = setInterval(() => {
    if (window.scrollY !== 0) {
      window.scrollBy(0, step);
    } else clearInterval(scrollInterval);
  }, 15);
};

/* harmony default export */ __webpack_exports__["Z"] = (scrollToTop);

/***/ }),

/***/ 50616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ accordion; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Item/index.js + 5 modules
var Item = __webpack_require__(81572);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Accordion/accordion.styles.js



const byType = {
  text: styled_components_browser_esm/* css */.iv`
    font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
    line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.plus')(props)}px;
    color: ${props => (0,build_esm/* getTextColor */.uu)('scratched')(props)};

    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;

    ${props => props.open ? styled_components_browser_esm/* css */.iv`
            max-height: 54px;
            margin-bottom: 16px;
          ` : styled_components_browser_esm/* css */.iv`
            max-height: 0px;
          `}
  `,
  component: styled_components_browser_esm/* css */.iv`
    max-height: ${props => props.open ? '100%' : '0px'};
  `
};
const Container = (0,styled_components_browser_esm/* default */.ZP)(Item/* default */.Z).attrs(props => Object.assign({
  cursor: 'pointer',
  outline: 'none',
  py: 0,
  gap: 0
}, props))``;
const Header = (0,styled_components_browser_esm/* default */.ZP)(Container.Header)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  padding-right: 8px;
`;
const Content = (0,styled_components_browser_esm/* default */.ZP)(Container.Content)`
  overflow: hidden;
  transition: max-height 0.3s ease-out;

  ${props => props.isText ? byType.text : byType.component}
`;
const IconsContainer = styled_components_browser_esm/* default.div */.ZP.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(30px, max-content));
  justify-content: center;
  padding: 8px;
  grid-gap: ${props => (0,build_esm/* themeGet */.R)('space.4')(props)}px;
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Accordion/accordion.js








const Accordion = /*#__PURE__*/(0,react.forwardRef)((_ref, ref) => {
  let {
    asTitle,
    children,
    id,
    textAlign,
    openIcon,
    closeIcon,
    title,
    innerControl,
    open,
    fontSize,
    fontWeight,
    onClick
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["asTitle", "children", "id", "textAlign", "openIcon", "closeIcon", "title", "innerControl", "open", "fontSize", "fontWeight", "onClick"]);

  const [show, setShow] = (0,react.useState)(false);
  const isText = typeof children === 'string';
  const showContent = innerControl ? show : open;
  const iconName = id ? `Category${id}` : undefined;

  const handleClick = () => {
    setShow(!show);
    onClick();
  };

  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    ref: ref
  }, props), /*#__PURE__*/react.createElement(Header, {
    scale: "large",
    fill: "background.dark",
    endIcon: open ? closeIcon : openIcon,
    onClick: handleClick
  }, /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    justifyContent: "flex-start",
    alignItems: "center"
  }, iconName && /*#__PURE__*/react.createElement(IconsContainer, null, /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    name: iconName,
    fill: "background.primary"
  })), /*#__PURE__*/react.createElement(Heading/* default */.Z, {
    as: asTitle,
    fontSize: fontSize,
    fontWeight: fontWeight
  }, title))), /*#__PURE__*/react.createElement(Content, {
    open: showContent,
    isText: isText,
    textAlign: textAlign
  }, children));
});
 false ? 0 : void 0;
Accordion.defaultProps = {
  asTitle: 'h2',
  children: null,
  textAlign: 'justify',
  openIcon: 'ChevronRight',
  closeIcon: 'ChevronRight',
  innerControl: false,
  open: false,
  fontSize: 2,
  fontWeight: 'medium'
};
Accordion.displayName = 'Accordion';
/* harmony default export */ var accordion = (Accordion);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Accordion/index.js


/***/ }),

/***/ 59120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; },
/* harmony export */   "z": function() { return /* binding */ BaseButtonStyle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99673);

const BaseButtonStyle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv`
  border: none;
  cursor: pointer;

  background: none;

  transition: all 0.2s ease-in-out;

  &:disabled {
    opacity: 0.5;
  }
`;
const Container = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].button */ .ZP.button`
  position: relative;
  width: 100%;
  height: 100%;

  ${BaseButtonStyle}

  ${({
  noHover
}) => !noHover && styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv`
      &:hover:not(:disabled) {
        transform: scale(1.1);
      }
    `}
`;

/***/ }),

/***/ 66685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ base_button; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/BaseButton/base-button.styles.js
var base_button_styles = __webpack_require__(59120);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/BaseButton/base-button.js






function BaseButton(_ref) {
  let {
    children
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["children"]);

  return /*#__PURE__*/react.createElement(base_button_styles/* Container */.W, (0,esm_extends/* default */.Z)({
    "data-testid": "base-button",
    role: "button"
  }, props), children);
}

BaseButton.defaultProps = {
  noHover: false,
  onClick: () => {}
};
 false ? 0 : void 0;
/* harmony default export */ var base_button = (BaseButton);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/BaseButton/index.js


/***/ }),

/***/ 84546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ box; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/box.styles.js



const Container = styled_components_browser_esm/* default.div */.ZP.div({
  boxSizing: 'border-box',
  cursor: ({
    touch
  }) => touch ? 'pointer' : 'inherit'
}, (0,index_esm/* compose */.qC)(index_esm/* background */.Oq, index_esm/* border */.Cg, index_esm/* layout */.bK, index_esm/* position */.FK, index_esm/* shadow */.AF, index_esm/* space */.Dh, index_esm/* textAlign */.yd, index_esm/* typography */.cp, esm/* color */.$_), esm/* textContrast */.Tf);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/box.js





/**
 * Use the `Box` component to control width, margin, padding, and color.
 */

const Box = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    children
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["children"]);

  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    ref: ref
  }, props), children);
});
Box.propTypes = {
  children: (0,prop_types.oneOfType)([prop_types.element, prop_types.string, (0,prop_types.arrayOf)(prop_types.element), prop_types.node])
};
Box.defaultProps = {
  children: undefined
};
Box.displayName = 'Box';
/* harmony default export */ var box = (Box);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js


/***/ }),

/***/ 60861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Button_button; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/button.styles.js




const sizes = {
  auto: styled_components_browser_esm/* css */.iv`
    height: auto;
    min-width: auto;
  `,
  small: styled_components_browser_esm/* css */.iv`
    height: 32px;
    min-width: 80px;
    font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.0')(props)}px;
  `,
  medium: styled_components_browser_esm/* css */.iv`
    height: 44px;
    min-width: 140px;
    font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
  `,
  large: styled_components_browser_esm/* css */.iv`
    height: 52px;
    min-width: 180px;
    font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.2')(props)}px;
  `
};
const variations = {
  fill: styled_components_browser_esm/* css */.iv`
    ${props => {
    var _props$customColor, _props$customColor2, _props$customColor3, _props$customColor4;

    return `
      background-color: 
        ${(_props$customColor = props.customColor) != null && _props$customColor.default ? (_props$customColor2 = props.customColor) == null ? void 0 : _props$customColor2.default : (0,build_esm/* getPaletteColor */.ow)('base')(props)};
      color: ${(0,build_esm/* getTextColor */.uu)('lightest')(props)};
      svg {
        fill: ${(0,build_esm/* getTextColor */.uu)('lightest')(props)};
      }

      &:hover {
        background-color: 
        ${(_props$customColor3 = props.customColor) != null && _props$customColor3.hover ? (_props$customColor4 = props.customColor) == null ? void 0 : _props$customColor4.hover : (0,build_esm/* getPaletteColor */.ow)('dark')(props)};
        color: ${(0,build_esm/* getTextColor */.uu)('lightest')(props)};
      }
    `;
  }};

    ${props => props.disabled && `
      &,
      &:hover {
        background-color: ${(0,build_esm/* getPaletteColor */.ow)('background.whisper')(props)};
        color: ${(0,build_esm/* getTextColor */.uu)('scratched')(props)};
        svg {
          fill: ${(0,build_esm/* getTextColor */.uu)('scratched')(props)};
        }
      }
    `};

    ${props => {
    var _props$customColor5, _props$customColor6, _props$customColor7, _props$customColor8, _props$customColor9, _props$customColor10, _props$customColor11, _props$customColor12, _props$customColor13, _props$customColor14;

    return !props.disabled && props.invertedColors && `
      background-color: 
        ${(_props$customColor5 = props.customColor) != null && _props$customColor5.default ? (_props$customColor6 = props.customColor) == null ? void 0 : _props$customColor6.default : (0,build_esm/* getPaletteColor */.ow)('base')(props)};
      color:
        ${(_props$customColor7 = props.customColor) != null && _props$customColor7.hover ? (_props$customColor8 = props.customColor) == null ? void 0 : _props$customColor8.hover : (0,build_esm/* getTextColor */.uu)('lightest')(props)};
      svg {
        fill: ${(0,build_esm/* getTextColor */.uu)('lightest')(props)};
      }

      &:hover {
        background-color:
          ${(_props$customColor9 = props.customColor) != null && _props$customColor9.hover ? (_props$customColor10 = props.customColor) == null ? void 0 : _props$customColor10.hover : (0,build_esm/* getTextColor */.uu)('lightest')(props)};
        color: ${(_props$customColor11 = props.customColor) != null && _props$customColor11.default ? (_props$customColor12 = props.customColor) == null ? void 0 : _props$customColor12.default : (0,build_esm/* getPaletteColor */.ow)('base')(props)};
        svg {
          fill: ${(_props$customColor13 = props.customColor) != null && _props$customColor13.hover ? (_props$customColor14 = props.customColor) == null ? void 0 : _props$customColor14.hover : (0,build_esm/* getPaletteColor */.ow)('base')(props)};
        }
      }
    `;
  }};
  `,
  outline: styled_components_browser_esm/* css */.iv`
    ${props => {
    var _props$customColor15, _props$customColor16, _props$customColor17, _props$customColor18, _props$customColor19, _props$customColor20, _props$customColor21, _props$customColor22, _props$customColor23, _props$customColor24, _props$customColor25, _props$customColor26;

    return `
    background-color: transparent;
    box-shadow: inset 0 0 0 1px
      ${(_props$customColor15 = props.customColor) != null && _props$customColor15.default ? (_props$customColor16 = props.customColor) == null ? void 0 : _props$customColor16.default : (0,build_esm/* getPaletteColor */.ow)('base')(props)};
    color: ${(_props$customColor17 = props.customColor) != null && _props$customColor17.default ? (_props$customColor18 = props.customColor) == null ? void 0 : _props$customColor18.default : (0,build_esm/* getPaletteColor */.ow)('base')(props)};
    svg {
      fill: ${(_props$customColor19 = props.customColor) != null && _props$customColor19.default ? (_props$customColor20 = props.customColor) == null ? void 0 : _props$customColor20.default : (0,build_esm/* getPaletteColor */.ow)('base')(props)};
    }

    &:hover {
      box-shadow: inset 0 0 0 1px
        ${(_props$customColor21 = props.customColor) != null && _props$customColor21.hover ? (_props$customColor22 = props.customColor) == null ? void 0 : _props$customColor22.hover : (0,build_esm/* getPaletteColor */.ow)('dark')(props)};
      color: ${(_props$customColor23 = props.customColor) != null && _props$customColor23.hover ? (_props$customColor24 = props.customColor) == null ? void 0 : _props$customColor24.hover : (0,build_esm/* getPaletteColor */.ow)('dark')(props)};
      svg {
        fill: ${(_props$customColor25 = props.customColor) != null && _props$customColor25.hover ? (_props$customColor26 = props.customColor) == null ? void 0 : _props$customColor26.hover : (0,build_esm/* getPaletteColor */.ow)('dark')(props)};
      }
    }
  `;
  }}

    ${props => props.disabled && `
      &,
      &:hover {
        background-color: transparent;
        box-shadow: inset 0 0 0 1px ${(0,build_esm/* getTextColor */.uu)('lighter')(props)};
        color: ${(0,build_esm/* getTextColor */.uu)('lighter')(props)};
        svg {
          fill: ${(0,build_esm/* getTextColor */.uu)('lighter')(props)};
        }
      }
    `}
  `
};
const StartIcon = styled_components_browser_esm/* default.span */.ZP.span`
  grid-area: start;
  svg {
    vertical-align: middle;
    float: left;
  }
`;
const Content = styled_components_browser_esm/* default.label */.ZP.label`
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.medium')(props)};
  text-align: center;
  margin-top: 1px;
  grid-area: label;
  align-self: center;
  small {
    font-weight: ${props => (0,build_esm/* themeGet */.R)('fontWeights.medium')(props)};
    text-transform: none;
    display: block;
  }
`;
const EndIcon = styled_components_browser_esm/* default.span */.ZP.span`
  grid-area: end;
  svg {
    vertical-align: middle;
    float: right;
  }
`;
const ButtonBase = styled_components_browser_esm/* default.button */.ZP.button`
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  font-family: ${props => (0,build_esm/* themeGet */.R)('fontFamily')(props)};
  outline: none;
  border: none;
  border-radius: ${props => props.rounded ? '30px' : '4px'};
  padding: 0px 15px;
  width: ${props => props.full ? '100%' : 'auto'};
  display: grid;
  grid-column: ${props => props.gridColumn || 'unset'};
  grid-template-areas: ${props => !props.startIcon && !props.endIcon ? "'label'" : "'start label end'"};
  ${_ref => {
  let {
    centered
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["centered"]);

  return centered ? styled_components_browser_esm/* css */.iv`
          grid-template-columns: '';
          grid-gap: 0px
            ${props.startIcon || props.endIcon ? (0,build_esm/* themeGet */.R)('space.2')(props) : 0}px;
        ` : styled_components_browser_esm/* css */.iv`
          grid-template-columns: ${!props.startIcon && !props.endIcon ? 'auto' : '1fr 4fr 1fr'};
        `;
}}
  justify-content: center;
  align-content: center;
  text-decoration: none;
  ${Content} {
    ${({
  uppercase
}) => uppercase && styled_components_browser_esm/* css */.iv`
        text-transform: uppercase;
      `}
  }
  ${props => sizes[props.size] || sizes.medium}
  ${props => variations[props.variation] || variations.fill}
  ${index_esm/* space */.Dh}
  ${index_esm/* layout */.bK}
  ${index_esm/* typography */.cp}
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/button.js







const Button = _ref => {
  let {
    onClick
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["onClick"]);

  const {
    startIcon,
    endIcon,
    children,
    disabled
  } = props;

  const getIcon = icon => typeof icon === 'string' ? /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    name: icon
  }) : icon;

  return /*#__PURE__*/react.createElement(ButtonBase, (0,esm_extends/* default */.Z)({
    onClick: e => onClick(e)
  }, props), startIcon && /*#__PURE__*/react.createElement(StartIcon, null, getIcon(startIcon)), /*#__PURE__*/react.createElement(Content, {
    disabled: disabled
  }, children), endIcon && /*#__PURE__*/react.createElement(EndIcon, null, getIcon(endIcon)));
};

 false ? 0 : void 0;
Button.defaultProps = {
  centered: false,
  children: undefined,
  color: 'primary',
  customColor: {
    default: null,
    hover: null
  },
  disabled: false,
  invertedColors: false,
  onClick: () => {},
  rounded: false,
  size: 'medium',
  uppercase: true,
  variation: 'fill'
};
Button.displayName = 'Button';
/* harmony default export */ var Button_button = (Button);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js


/***/ }),

/***/ 27439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* reexport */ card; }
});

// UNUSED EXPORTS: CardBody, CardImage, CardText, CardTitle

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Card/card.styles.js



 // Components



 // Extend style from responsive image component


const truncateText = lines => styled_components_browser_esm/* css */.iv`
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${lines};
`;
const Container = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) => prop.includes('ads-') || prop.includes('redirect') ? true : defaultValidatorFn(prop)
}).attrs(props => {
  return Object.assign({}, props);
})({
  transition: 'box-shadow ease 0.4s',
  textDecoration: 'none',
  cursor: 'pointer',
  display: 'grid',
  overflow: 'hidden',
  gridTemplateAreas: '"image" "body"',
  justifyContent: 'space-between',
  borderRadius: (0,esm/* themeGet */.R)('radii.default')
}, _ref => {
  let {
    enableHover
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["enableHover"]);

  return enableHover && {
    ':hover': {
      boxShadow: (0,esm/* themeGet */.R)('boxShadows.4')(props)
    }
  };
}, (0,index_esm/* compose */.qC)(index_esm/* background */.Oq, esm/* color */.$_, index_esm/* space */.Dh, index_esm/* grid */.eC, index_esm/* layout */.bK, index_esm/* flex */.fU), esm/* textContrast */.Tf);
const CardImage = (0,styled_components_browser_esm/* default */.ZP)(ResponsiveImage/* default */.Z).attrs(props => Object.assign({
  imageWidth: '100%',
  imageHeight: '100%',
  objectFit: 'cover'
}, props))`
  grid-area: image;
`;
const CardBody = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(props => Object.assign({
  color: 'inherit',
  background: 'inherit',
  padding: '16px 14px',
  flexDirection: 'column'
}, props))`
  grid-area: body;
`;
const CardTitle = (0,styled_components_browser_esm/* default */.ZP)(Heading/* default */.Z).attrs(props => Object.assign({
  fontSize: 6,
  color: 'inherit',
  lineHeight: '1.2em'
}, props))`
  ${({
  truncate,
  lines = 2
}) => truncate && truncateText(lines)}
`;
const CardSubtitle = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(props => Object.assign({
  forwardedAs: 'small',
  color: 'inherit',
  display: 'block',
  fontSize: 0,
  marginTop: 2
}, props))`
  ${({
  truncate,
  lines = 2
}) => truncate && truncateText(lines)}
`;
const CardText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(props => Object.assign({
  fontSize: 2,
  fontWeight: 'light',
  lineHeight: '1.5em',
  color: 'inherit',
  marginTop: '3'
}, props))`
  ${({
  truncate,
  lines = 4
}) => truncate && truncateText(lines)}
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Card/card.js





const Card = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    children
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["children"]);

  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    ref: ref
  }, props), children);
});
Card.displayName = 'Card';
 false ? 0 : void 0;
Card.Image = CardImage;
Card.Title = CardTitle;
Card.Subtitle = CardSubtitle;
Card.Text = CardText;
Card.Body = CardBody;
const SharedTypes = {
  truncate: prop_types.bool,
  lines: prop_types.number
};
Card.Title.propTypes = Object.assign({}, SharedTypes);
Card.Subtitle.propTypes = Object.assign({}, SharedTypes);
Card.Text.propTypes = Object.assign({}, SharedTypes);
/* harmony default export */ var card = (Card);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Card/index.js



/***/ }),

/***/ 18281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Checkbox_checkbox; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Checkbox/checkbox.styles.js




const Container = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(_ref => {
  let {
    color,
    disabled
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["color", "disabled"]);

  return Object.assign({
    alignItems: 'center',
    color: disabled ? 'text.gray' : color
  }, props);
})``;
const Input = styled_components_browser_esm/* default.input.attrs */.ZP.input.attrs(() => ({
  type: 'checkbox'
}))`
  appearance: none;
  background: transparent;
  width: 20px;
  height: 20px;
  outline: none;
  cursor: pointer;

  &:not(:checked) {
    border-radius: ${(0,esm/* themeGet */.R)('radii.medium')};
    border: ${(0,esm/* themeGet */.R)('borders.1')};
  }

  &:checked {
    &:after {
      content: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGlkPSJzdmdJZCIgZmlsbD0iI2ZmZiIgdmlld0JveD0iMCAwIDI0IDI0IiBjbGFzcz0ic2MtYlpReW5NIGpjVFFtYyI+PHBhdGggZD0iTTkgMTYuMkw0LjggMTJsLTEuNCAxLjRMOSAxOSAyMSA3bC0xLjQtMS40TDkgMTYuMnoiLz48L3N2Zz4=');
      position: absolute;
      width: 20px;
      height: 20px;
      background: ${(0,esm/* getBackgroundColor */.dF)('primary')};
      border-radius: ${(0,esm/* themeGet */.R)('radii.medium')};
      box-sizing: border-box;
    }

    &:disabled {
      &:after {
        background: ${(0,esm/* getBackgroundColor */.dF)('dark')};
      }
    }
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Checkbox/checkbox.js





const Checkbox = /*#__PURE__*/(0,react.forwardRef)((_ref, ref) => {
  let {
    children,
    checked,
    defaultChecked,
    disabled,
    value,
    onChange,
    label,
    name,
    as
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["children", "checked", "defaultChecked", "disabled", "value", "onChange", "label", "name", "as"]);

  const input = /*#__PURE__*/react.createElement(Input, {
    onChange: e => onChange(e, value),
    checked: checked,
    disabled: disabled,
    defaultChecked: defaultChecked,
    ref: ref,
    value: value,
    name: name,
    "data-testid": "checkbox-item"
  });
  return children || label ? /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    forwardedAs: as,
    disabled: disabled
  }, props, {
    "data-testid": "checkbox"
  }), input, label || children) : input;
});
 false ? 0 : void 0;
Checkbox.defaultProps = {
  children: null,
  disabled: false,
  color: 'text.base',
  as: 'label',
  gap: 2,
  onChange: () => {}
};
Checkbox.displayName = 'Checkbox';
/* harmony default export */ var Checkbox_checkbox = (Checkbox);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Checkbox/index.js


/***/ }),

/***/ 17781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ chip; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Chip/chip.styles.js




const DEFAULT_BG_COLOR = 'primary';
const SCALES_VARIATIONS = {
  light: esm/* theme.palette.text.white */.rS.palette.text.white,
  dark: esm/* theme.palette.text.base */.rS.palette.text.base
};
const displayTransition = `
  -webkit-transition: all 500ms ease;
  transition: all 500ms ease;
`;
const displayBase = `
  ${displayTransition}
  -moz-user-select: -moz-none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;
const displaySize = {
  xsmall: '18px',
  small: '28px',
  medium: '38px'
};

const displayColorLayout = ({
  props,
  variation,
  checked = false
}) => {
  const {
    bg,
    type,
    scales = SCALES_VARIATIONS
  } = props;
  const variations = {
    colorfulTransition: styled_components_browser_esm/* css */.iv`
      ${displayTransition}
      background-color: ${(0,esm/* getBackgroundColor */.dF)(bg || DEFAULT_BG_COLOR)(props)};
      color: ${(0,esm/* getTextContrast */.jk)(bg || DEFAULT_BG_COLOR, scales)(props)};
      > svg {
        ${displayTransition}
        fill: ${(0,esm/* getTextContrast */.jk)(bg || DEFAULT_BG_COLOR, scales)(props)};
      }
    `,
    colorful: styled_components_browser_esm/* css */.iv`
      ${displayTransition}
      background-color: ${(0,esm/* getBackgroundColor */.dF)(bg || DEFAULT_BG_COLOR)(props)};
      color: ${(0,esm/* getTextContrast */.jk)(bg || DEFAULT_BG_COLOR, scales)(props)};
      > svg {
        ${displayTransition}
        fill: ${(0,esm/* getTextContrast */.jk)(bg || DEFAULT_BG_COLOR, scales)(props)};
      }
    `,
    default: styled_components_browser_esm/* css */.iv`
      background-color: ${(0,esm/* getBackgroundColor */.dF)('white')(props)};
      color: ${(0,esm/* getTextContrast */.jk)('white', scales)(props)};
    `
  };
  const variationType = bg && (checked || !type.includes('radio', 'checkbox')) ? 'colorful' : 'default';
  return variations[variation || variationType];
};

const Container = styled_components_browser_esm/* default.div */.ZP.div`
  ${index_esm/* margin */.e6}
  ${index_esm/* layout */.bK}
  text-decoration: none;
`;
const Label = styled_components_browser_esm/* default.label */.ZP.label`
  display: flex;
  justify-content: ${({
  justify
}) => justify};
  align-items: center;
  border: ${({
  hasBorder
}) => hasBorder ? '1px solid' : 'none'};
  scroll-snap-align: center;
  border-radius: ${props => (0,esm/* themeGet */.R)('space.4')(props)}px;

  min-width: ${({
  minWidth
}) => minWidth};
  height: ${props => displaySize[props == null ? void 0 : props.size]};

  ${props => displayColorLayout({
  props
})};

  ${({
  autoSize
}) => autoSize ? styled_components_browser_esm/* css */.iv`
          justify-content: space-around;
          width: auto;
          min-width: auto;
          height: auto;
          padding: ${(0,esm/* themeGet */.R)('space.2')}px ${(0,esm/* themeGet */.R)('space.2')}px;
        ` : styled_components_browser_esm/* css */.iv`
          max-width: ${({
  maxWidth
}) => maxWidth};
        `}

  ${displayBase}
  ${displayTransition}
  ${index_esm/* borderRadius */.E0}
  ${index_esm/* padding */.o3}
  ${index_esm/* fontSize */.JB}
  ${index_esm/* fontWeight */.Ue}
  ${index_esm/* gridGap */.Cc}
`;
const Text = styled_components_browser_esm/* default.p */.ZP.p`
  max-width: ${({
  textMaxWidth
}) => textMaxWidth};
  font-size: inherit;
  font-weight: inherit;
  line-height: ${props => (0,esm/* themeGet */.R)('lineHeights.standard')(props)}px;
  font-stretch: normal;
  letter-spacing: normal;

  ${_ref => {
  let {
    color
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["color"]);

  return color && styled_components_browser_esm/* css */.iv`
      color: ${(0,esm/* getTextColor */.uu)(color)(props)};
    `;
}}

  ${({
  autoSize
}) => autoSize && styled_components_browser_esm/* css */.iv`
      max-width: 100%;
    `};
`;
const Input = styled_components_browser_esm/* default.input */.ZP.input`
  ${displayBase}
  display: none;

  &:checked + ${Label} {
    ${props => displayColorLayout({
  props,
  variation: 'colorfulTransition',
  checked: true
})};
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Chip/chip.js






const Chip = _ref => {
  let {
    as,
    checked,
    clickable,
    startIcon,
    children,
    autoSize,
    endIcon,
    value,
    color,
    gridGap,
    size,
    name,
    type,
    id,
    bg,
    scales,
    onChange,
    onClick,
    hasBorder,
    textMaxWidth
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["as", "checked", "clickable", "startIcon", "children", "autoSize", "endIcon", "value", "color", "gridGap", "size", "name", "type", "id", "bg", "scales", "onChange", "onClick", "hasBorder", "textMaxWidth"]);

  const typeAs = clickable ? as || 'a' : as || 'div';
  const labelProps = clickable && {
    onChange
  };

  const onChangeInput = event => {
    var _event$target, _event$target2;

    onChange({
      value: event == null ? void 0 : (_event$target = event.target) == null ? void 0 : _event$target.value,
      selected: event == null ? void 0 : (_event$target2 = event.target) == null ? void 0 : _event$target2.checked
    });
  };

  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({}, props, {
    as: typeAs,
    "data-testid": "chip-container"
  }), type && /*#__PURE__*/react.createElement(Input, {
    "data-testid": "chip-input",
    checked: checked,
    onChange: onChangeInput,
    value: value,
    type: type,
    name: name,
    bg: bg,
    scales: scales,
    id: id
  }), /*#__PURE__*/react.createElement(Label, (0,esm_extends/* default */.Z)({
    "data-testid": "chip-label",
    onClick: onClick,
    gridGap: gridGap,
    clickable: clickable,
    startIcon: startIcon,
    autoSize: autoSize,
    endIcon: endIcon,
    size: size,
    htmlFor: id,
    bg: bg,
    type: type,
    hasBorder: hasBorder,
    scales: scales
  }, props, labelProps), startIcon, /*#__PURE__*/react.createElement(Text, {
    autoSize: autoSize,
    clickable: clickable,
    color: color,
    bg: bg,
    textMaxWidth: textMaxWidth
  }, children), endIcon));
};

 false ? 0 : void 0;
Chip.defaultProps = {
  onChange: () => {},
  onClick: () => {},
  type: '',
  clickable: false,
  startIcon: null,
  size: 'medium',
  children: null,
  gridGap: 2,
  bg: '',
  fontSize: 0,
  fontWeight: 'regular',
  hasBorder: false,
  endIcon: null,
  value: '',
  color: '',
  name: '',
  id: '',
  justify: 'center',
  minWidth: '66px',
  maxWidth: '144px',
  textMaxWidth: '60%'
};
/* harmony default export */ var chip = (Chip);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Chip/index.js


/***/ }),

/***/ 88699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ collapse; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Grid/index.js + 2 modules
var Grid = __webpack_require__(8341);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Collapse/collapse.styles.js


const Container = (0,styled_components_browser_esm/* default */.ZP)(Grid/* default */.Z)`
  display: grid;
  ${({
  trigger,
  collapsedIn
}) => trigger && styled_components_browser_esm/* css */.iv`
      > *:nth-child(n + ${collapsedIn}) {
        display: none;
        overflow: hidden;
        max-height: 0;
      }
    `};
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Collapse/collapse.js






const Collapse = _ref => {
  let {
    children,
    trigger,
    collapsedIn
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["children", "trigger", "collapsedIn"]);

  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    trigger: trigger,
    collapsedIn: collapsedIn + 1,
    "data-testid": "collapse"
  }, props), react.Children.toArray(children).map(element => /*#__PURE__*/react.isValidElement(element) && /*#__PURE__*/react.cloneElement(element)));
};

 false ? 0 : void 0;
Collapse.defaultProps = {
  trigger: false,
  children: null,
  collapsedIn: 0
};
Collapse.displayName = 'Collapse';
/* harmony default export */ var collapse = (Collapse);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Collapse/index.js


/***/ }),

/***/ 58331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ confirm_button; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ConfirmButton/confirm-button.js







const byType = {
  like: {
    icon: 'Like'
  },
  dislike: {
    icon: 'Dislike'
  }
};

function ConfirmButton(_ref) {
  let {
    type,
    label,
    onClick,
    color
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["type", "label", "onClick", "color"]);

  const {
    icon
  } = byType[type];
  return /*#__PURE__*/react.createElement(Flex/* default */.Z, (0,esm_extends/* default */.Z)({
    alignItems: "center",
    onClick: onClick
  }, props), /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    name: icon,
    color: color,
    cursor: "pointer"
  }), /*#__PURE__*/react.createElement(Text/* default */.Z, {
    ml: "6px"
  }, label));
}

 false ? 0 : void 0;
/* harmony default export */ var confirm_button = (ConfirmButton);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ConfirmButton/index.js


/***/ }),

/***/ 37270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "Xk": function() { return /* binding */ Paper; },
/* harmony export */   "aV": function() { return /* binding */ Overlay; },
/* harmony export */   "bo": function() { return /* binding */ HorizontalRule; },
/* harmony export */   "f": function() { return /* binding */ CloseComponent; },
/* harmony export */   "h4": function() { return /* binding */ Header; },
/* harmony export */   "yW": function() { return /* binding */ ContentHeader; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99673);
/* harmony import */ var _magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55403);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86349);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84546);
/* harmony import */ var _Flex__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19527);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63825);






const paperPositions = {
  top: styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv`
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    animation: ${_utils__WEBPACK_IMPORTED_MODULE_1__/* .slideFromTop */ .ie} 0.3s ease-in-out;
  `,
  center: styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv`
    margin: 15px;
    animation: ${_utils__WEBPACK_IMPORTED_MODULE_1__/* .fadeIn */ .Ji} 0.3s ease-in;
  `,
  bottom: styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv`
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    animation: ${_utils__WEBPACK_IMPORTED_MODULE_1__/* .slideFromBottom */ .$7} 0.3s ease-in-out;
  `
};

const paperTypes = ({
  type,
  fullScreen
}) => {
  if (fullScreen) return styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv`
      width: 100%;
      border-radius: ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_0__/* .themeGet */ .R)('radii.default')};
    `;
  if (type === 'alert') return styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv`
      width: 300px;
      border-radius: ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_0__/* .themeGet */ .R)('radii.medium')};
    `;
  if (type === 'responsive') return styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv`
      padding: ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_0__/* .themeGet */ .R)('space.4')}px;
      border-radius: ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_0__/* .themeGet */ .R)('radii.default')};
      overflow-x: hidden;
    `;
  if (type === 'full') return styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv`
      max-width: 1366px;
      width: 100%;
    `;
  return styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv`
    width: 85%;
    max-width: 1366px;
    border-radius: ${(0,_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_0__/* .themeGet */ .R)('radii.default')};
  `;
};

const alignContentBy = {
  top: styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv`
    justify-content: flex-start;
  `,
  center: styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv`
    justify-content: center;
  `,
  bottom: styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv`
    justify-content: flex-end;
  `
};
const Overlay = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs(() => ({
  bg: 'background.overlay'
}))`
  animation: ${_utils__WEBPACK_IMPORTED_MODULE_1__/* .fadeIn */ .Ji} 0.3s linear;
  -webkit-overflow-scrolling: touch;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  cursor: pointer;
`;
const Container = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_Flex__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs(props => ({
  zIndex: 4,
  padding: props.fullScreen ? 4 : undefined
}))`
  flex-direction: column;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  ${props => alignContentBy[props.position]}
  visibility: ${({
  visible
}) => visible ? 'visible' : 'hidden'};
`;
const Title = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs(props => Object.assign({
  color: 'text.dark',
  fontSize: 3,
  p: 2
}, props.titleStyle))`
  margin: 6px 0;
  width: 100%;
`;
const ContentHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_Flex__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)`
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
const HorizontalRule = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].hr */ .ZP.hr`
  height: ${({
  size
}) => `${size}px`};
  width: 100vh;
  border: none;
  ${_magalu_stereo_ui_styles__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_}
`;
const Paper = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs(props => Object.assign({
  p: 3,
  bg: 'background.base',
  zIndex: 1
}, props))`
  overflow-x: auto;
  ${props => paperPositions[props.position]}
  ${props => paperTypes(props)}
`;
const Header = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_Flex__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)`
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
`;
const CloseComponent = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div */ .ZP.div`
  padding-right: 8px;
  margin-left: auto;
  cursor: pointer;
`;

/***/ }),

/***/ 66762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ dialog; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Portal/index.js + 1 modules
var Portal = __webpack_require__(75851);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dialog/dialog.styles.js
var dialog_styles = __webpack_require__(37270);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dialog/dialog.js








const withPortal = children => /*#__PURE__*/react.createElement(Portal/* default */.Z, {
  id: "portal-dialog"
}, children);

const DialogComp = _ref => {
  let {
    portal = false
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["portal"]);

  const Component = /*#__PURE__*/react.createElement(Dialog, props);
  return portal ? withPortal(Component) : Component;
};

const Dialog = _ref2 => {
  let {
    title,
    showClose,
    onClickOutside,
    children,
    visible,
    position,
    fullScreen,
    type,
    titleStyle,
    ruleSize,
    bgRule,
    showHorizontalRule
  } = _ref2,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, ["title", "showClose", "onClickOutside", "children", "visible", "position", "fullScreen", "type", "titleStyle", "ruleSize", "bgRule", "showHorizontalRule"]);

  (0,react.useEffect)(() => {
    const originalStyle = window.getComputedStyle(document.body).overflow;
    document.body.style.overflow = visible ? 'hidden' : originalStyle;
    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, [visible]);
  return /*#__PURE__*/react.createElement(dialog_styles/* Container */.W2, {
    position: position,
    visible: visible,
    fullScreen: fullScreen,
    "data-testid": "dialog"
  }, /*#__PURE__*/react.createElement(dialog_styles/* Overlay */.aV, {
    onClick: onClickOutside,
    role: "dialog",
    "data-testid": "dialog-overlay"
  }), /*#__PURE__*/react.createElement(dialog_styles/* Paper */.Xk, (0,esm_extends/* default */.Z)({
    position: position,
    "data-testid": "dialog-content",
    type: type,
    fullScreen: fullScreen
  }, props), /*#__PURE__*/react.createElement(dialog_styles/* Header */.h4, null, /*#__PURE__*/react.createElement(dialog_styles/* ContentHeader */.yW, null, title && /*#__PURE__*/react.createElement(dialog_styles/* Title */.Dx, {
    titleStyle: titleStyle,
    "data-testid": "dialog-title"
  }, title), showClose && /*#__PURE__*/react.createElement(dialog_styles/* CloseComponent */.f, null, /*#__PURE__*/react.createElement(esm/* Close */.x8P, {
    color: "#999",
    "aria-label": "Close",
    onClick: onClickOutside,
    "data-testid": "dialog-close"
  }))), showHorizontalRule && /*#__PURE__*/react.createElement(dialog_styles/* HorizontalRule */.bo, {
    size: ruleSize,
    bg: bgRule,
    "data-testid": "horizontal-rule"
  })), children));
};

Dialog.defaultProps = {
  children: undefined,
  title: undefined,
  fullScreen: false,
  position: 'bottom',
  type: 'dialog',
  showClose: false,
  titleStyle: {},
  visible: true,
  ruleSize: 1,
  bgRule: 'border.light',
  showHorizontalRule: false
};
 false ? 0 : void 0;
/* harmony default export */ var dialog = (DialogComp);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dialog/index.js


/***/ }),

/***/ 74822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ dropdown; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dropdown/dropdown.styles.js







const DropdownItem = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(props => Object.assign({
  color: 'text.base',
  alignItems: 'center',
  p: 3
}, props))``;
const Container = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(props => Object.assign({
  display: 'inline-block'
}, props))``;
const ContainerTitle = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).attrs(_ref => {
  let {
    pointing
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["isOpen", "pointing"]);

  return Object.assign({
    position: 'relative',
    fontSize: 1,
    py: pointing ? 3 : 2,
    gridGap: 1
  }, props);
})``;
const ContainerMenu = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(_ref2 => {
  let props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, ["pointing"]);

  return Object.assign({
    position: 'absolute',
    color: 'text.base',
    bg: 'background.lighter',
    borderRadius: 'medium',
    zIndex: 1,
    minWidth: '10rem',
    maxHeight: '20rem',
    forwardedAs: 'ul'
  }, props);
})`
  border: ${(0,esm/* themeGet */.R)('borders.0')};

  ${({
  pointing
}) => pointing && styled_components_browser_esm/* css */.iv`
      &::before,
      &::after {
        content: '';
        position: absolute;
        bottom: 100%;
        left: 19px;
        border: 11px solid transparent;
        border-bottom-color: ${(0,esm/* themeGet */.R)('borders.0')};
      }

      &::after {
        left: 20px;
        border: 10px solid transparent;
        border-bottom-color: ${(0,esm/* getBackgroundColor */.dF)('lighter')};
      }
    `}
`;
const ContainerItem = (0,styled_components_browser_esm/* default */.ZP)(DropdownItem)`
  gap: ${(0,esm/* themeGet */.R)('space.1')}px;
  ${({
  disableHover
}) => !disableHover && styled_components_browser_esm/* css */.iv`
      &:hover {
        background-color: ${(0,esm/* getBackgroundColor */.dF)('darker')};
      }
    `}
`;
const ContainerLabel = (0,styled_components_browser_esm/* default */.ZP)(DropdownItem)`
  font-weight: ${props => (0,esm/* themeGet */.R)('fontWeights.medium')(props)};
`;
const ContainerIcon = (0,styled_components_browser_esm/* default */.ZP)(build_esm/* ChevronDown */._ME)`
  width: 20px;
  height: 20px;
  transition: transform 0.25s ease-out;
  transform: ${({
  rotated
}) => rotated && 'rotate(-180deg)'};
  ${esm/* color */.$_}
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dropdown/dropdown-context.js


const Context = /*#__PURE__*/(0,react.createContext)(false);

const DropdownContext = ({
  children,
  value
}) => /*#__PURE__*/react.createElement(Context.Provider, {
  value: value
}, children);

const useDropdownContext = () => (0,react.useContext)(Context);
 false ? 0 : void 0;
/* harmony default export */ var dropdown_context = (DropdownContext);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dropdown/dropdown-title.js







const DropdownTitle = _ref => {
  let {
    children,
    fill
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["children", "fill"]);

  const {
    isOpen,
    handleOnClick,
    pointing
  } = useDropdownContext();
  return /*#__PURE__*/react.createElement(ContainerTitle, (0,esm_extends/* default */.Z)({}, props, {
    isOpen: isOpen,
    pointing: pointing,
    onClick: handleOnClick,
    "data-testid": "dropdown-title"
  }), children, /*#__PURE__*/react.createElement(ContainerIcon, {
    fill: fill,
    rotated: isOpen
  }));
};

 false ? 0 : void 0;
DropdownTitle.defaultProps = {
  children: null,
  fill: 'text.base',
  underlineOnHover: false
};
DropdownTitle.displayName = 'DropdownTitle';
/* harmony default export */ var dropdown_title = (DropdownTitle);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dropdown/dropdown-menu.js







const DropdownMenu = _ref => {
  let {
    children
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["children"]);

  const {
    isOpen,
    pointing
  } = useDropdownContext();
  return isOpen ? /*#__PURE__*/react.createElement(ContainerMenu, (0,esm_extends/* default */.Z)({}, props, {
    pointing: pointing,
    "data-testid": "dropdown-menu"
  }), children) : null;
};

 false ? 0 : void 0;
DropdownMenu.defaultProps = {
  children: null,
  fontSize: 1,
  forwardedAs: 'ul'
};
DropdownMenu.displayName = 'DropdownMenu';
/* harmony default export */ var dropdown_menu = (DropdownMenu);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dropdown/dropdown-label.js





const DropdownLabel = _ref => {
  let {
    children,
    startIcon,
    endIcon
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["children", "startIcon", "endIcon"]);

  return /*#__PURE__*/react.createElement(ContainerLabel, props, startIcon, children, endIcon);
};

 false ? 0 : void 0;
DropdownLabel.defaultProps = {
  children: null,
  startIcon: null,
  endIcon: null,
  forwardedAs: 'li'
};
DropdownLabel.displayName = 'DropdownLabel';
/* harmony default export */ var dropdown_label = (DropdownLabel);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dropdown/dropdown-item.js







const dropdown_item_DropdownItem = _ref => {
  let {
    children,
    value,
    startIcon,
    endIcon
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["children", "value", "startIcon", "endIcon", "onClick"]);

  const {
    setIsOpen,
    handleOnChange
  } = useDropdownContext();

  const handleOnClick = e => {
    setIsOpen(false);
    handleOnChange(e, {
      value
    });
  };

  return /*#__PURE__*/react.createElement(ContainerItem, (0,esm_extends/* default */.Z)({}, props, {
    role: "option",
    onClick: handleOnClick,
    "data-testid": "dropdown-item"
  }), startIcon, children, endIcon);
};

 false ? 0 : void 0;
dropdown_item_DropdownItem.defaultProps = {
  children: null,
  value: null,
  startIcon: null,
  endIcon: null,
  disableHover: false,
  forwardedAs: 'li'
};
dropdown_item_DropdownItem.displayName = 'DropdownItem';
/* harmony default export */ var dropdown_item = (dropdown_item_DropdownItem);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/HorizontalRule/index.js + 2 modules
var HorizontalRule = __webpack_require__(97600);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dropdown/dropdown.js













const DropdownDivider = props => {
  return /*#__PURE__*/react.createElement(HorizontalRule/* default */.Z, props);
};

const Dropdown = _ref => {
  let {
    title,
    children,
    options,
    onClick,
    onChange,
    mouseenter,
    pointing
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["title", "children", "options", "onClick", "onChange", "mouseenter", "pointing"]);

  const ref = (0,react.useRef)();
  const [isOpen, setIsOpen] = (0,react.useState)(false);

  if (mouseenter) {
    (0,utils/* useOnMouseHover */.Ay)(ref, setIsOpen);
  } else {
    (0,utils/* useOnClickOutside */.t$)(ref, () => setIsOpen(false));
  }
  /**
   * Update onClick function when user click over [Dropdown.Title]
   * to open [Dropdown.Menu]
   *
   * @param  {} e
   */


  const handleOnClick = e => {
    /* istanbul ignore else */
    if (!mouseenter) setIsOpen(!isOpen);
    onClick(e);
  };
  /**
   * Update onChange function when user click on a [Dropdown.Item]
   *
   * @param  {} e
   * @param  {} {value}
   */


  const handleOnChange = (e, {
    value
  }) => {
    onChange(e, {
      value
    });
  };
  /**
   * Build [Dropdown.Items] when user send [options] props
   * @example [{ key: '', label: '' ...}, { key: '', label: '' ...}]
   */


  const buildByOptions = () => /*#__PURE__*/react.createElement(dropdown_menu, {
    mouseenter: mouseenter,
    pointing: pointing
  }, options == null ? void 0 : options.map(_ref2 => {
    let {
      key,
      text,
      value,
      startIcon,
      endIcon
    } = _ref2,
        others = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, ["key", "text", "value", "startIcon", "endIcon"]);

    return /*#__PURE__*/react.createElement(dropdown_item, (0,esm_extends/* default */.Z)({
      key: key,
      value: value,
      startIcon: startIcon,
      endIcon: endIcon
    }, others), text);
  }));
  /**
   * Build [Dropdown.Title] according to component structure
   *
   * There are 2 ways to use a title
   * @example <Dropdown title="dropdown"></Dropdown>
   *          <Dropdown title={<span>dropdown</span>}></Dropdown>
   *
   * @example <Dropdown>
   *            <Dropdown.Title>Dropdown</Dropdown.Title>
   *          </Dropdown>
   */


  const buildDropdownTitle = () => {
    const TitleComponent = react.Children.toArray(children).find(({
      type: {
        displayName
      }
    }) => displayName === 'DropdownTitle');
    if (TitleComponent) return /*#__PURE__*/react.isValidElement(TitleComponent) && TitleComponent;
    return /*#__PURE__*/react.createElement(dropdown_title, props, title);
  };
  /**
   * Get only [Dropdown.Menu] from [children] whether user send it
   *
   * @example <Dropdown.Menu>
   *            <Dropdown.Item>Dropdown Item</Dropdown.Item>
   *          </Dropdown.Menu>
   */


  const buildDropdownMenu = () => {
    return react.Children.toArray(children).find(({
      type: {
        displayName
      }
    }) => displayName === 'DropdownMenu');
  };

  return /*#__PURE__*/react.createElement(dropdown_context, {
    value: {
      isOpen,
      setIsOpen,
      handleOnClick,
      handleOnChange,
      pointing
    }
  }, /*#__PURE__*/react.createElement(Container, {
    ref: ref,
    "data-testid": "dropdown"
  }, buildDropdownTitle(), options ? buildByOptions() : buildDropdownMenu()));
};

 false ? 0 : void 0;
Dropdown.defaultProps = {
  children: null,
  mouseenter: false,
  pointing: false,
  onChange: () => {},
  onClick: () => {}
};
Dropdown.Title = dropdown_title;
Dropdown.Menu = dropdown_menu;
Dropdown.Label = dropdown_label;
Dropdown.Divider = DropdownDivider;
Dropdown.Item = dropdown_item;
DropdownDivider.displayName = 'DropdownDivider';
/* harmony default export */ var dropdown = (Dropdown);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dropdown/index.js


/***/ }),

/***/ 19527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ flex; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/flex.styles.js



const Container = styled_components_browser_esm/* default.div */.ZP.div({
  display: 'flex'
}, (0,index_esm/* compose */.qC)(index_esm/* flexbox */.GQ, index_esm/* background */.Oq, index_esm/* border */.Cg, index_esm/* layout */.bK, index_esm/* position */.FK, index_esm/* shadow */.AF, index_esm/* space */.Dh, index_esm/* textAlign */.yd, index_esm/* typography */.cp, esm/* color */.$_, esm/* cursor */.oc), esm/* gap */.SG);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/flex.js





/**
 * Use the `Flex` component to control flex style.
 * see flexbox -> https://styled-system.com/api#flexbox
 */

const Flex = /*#__PURE__*/(0,react.forwardRef)((_ref, ref) => {
  let {
    children
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["children"]);

  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    ref: ref
  }, props), children);
});
Flex.propTypes = {
  children: (0,prop_types.oneOfType)([prop_types.element, prop_types.string, (0,prop_types.arrayOf)(prop_types.element), prop_types.node])
};
Flex.defaultProps = {
  children: undefined
};
Flex.displayName = 'Flex';
/* harmony default export */ var flex = (Flex);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js


/***/ }),

/***/ 8341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ grid; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Grid/grid.styles.js




const Component = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)({
  display: 'grid'
}, (0,index_esm/* compose */.qC)(index_esm/* grid */.eC, index_esm/* typography */.cp, esm/* color */.$_, index_esm/* space */.Dh, esm/* gap */.SG));
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Grid/grid.js



/**
 * Use the `Grid` component to control grid style.
 * see grid -> https://styled-system.com/api#grid-layout
 */

const Grid = /*#__PURE__*/(0,react.forwardRef)((props, ref) => /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
  ref: ref
}, props)));
Grid.displayName = 'Grid';
/* harmony default export */ var grid = (Grid);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Grid/index.js


/***/ }),

/***/ 25610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ heading; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/heading.js





/**
 * A component for setting headings (h1...h6).
 */

const Heading = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    children
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["children"]);

  return /*#__PURE__*/react.createElement(Text/* default */.Z, (0,esm_extends/* default */.Z)({
    ref: ref,
    as: "h3",
    "data-testid": "main-title"
  }, props), children);
});
Heading.propTypes = {
  children: prop_types.string.isRequired
};
Heading.displayName = 'Heading';
/* harmony default export */ var heading = (Heading);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js


/***/ }),

/***/ 97600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ horizontal_rule; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/HorizontalRule/horizontal-rule.styles.js


const Rule = styled_components_browser_esm/* default.hr */.ZP.hr`
  height: ${({
  size
}) => `${size}px`};
  width: 100%;
  border: none;
  ${esm/* color */.$_}
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/HorizontalRule/horizontal-rule.js




const HorizontalRule = props => /*#__PURE__*/react.createElement(Rule, props);

 false ? 0 : void 0;
HorizontalRule.defaultProps = {
  size: 1,
  bg: 'border.light'
};
/* harmony default export */ var horizontal_rule = (HorizontalRule);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/HorizontalRule/index.js


/***/ }),

/***/ 39471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ HotLink_HotLink; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/HotLink/HotLink.styles.js






const ImageContent = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)`
  border-radius: 50%;
  width: ${props => (0,esm/* themeGet */.R)('sizes.hotLinks.width')(props)};
  height: ${props => (0,esm/* themeGet */.R)('sizes.hotLinks.height')(props)};
  margin-bottom: 8px;
`;
const Link = styled_components_browser_esm/* default.a */.ZP.a`
  display: block;
  text-decoration: none;
  width: 100%;
`;
const LinkImage = (0,styled_components_browser_esm/* default */.ZP)(ResponsiveImage/* default */.Z)``;
const columnStyle = styled_components_browser_esm/* css */.iv`
  flex-flow: wrap;
  background: ${props => (0,esm/* themeGet */.R)('palette.background.lighter')(props)};
  padding: 0 8px;
  border-left: 4px solid ${({
  borderColor
}) => borderColor || 'transparent'};
  width: 100%;
  border-radius: 4px;
  box-shadow: ${props => (0,esm/* themeGet */.R)('boxShadows.4')(props)};

  p {
    font-size: ${props => (0,esm/* themeGet */.R)('fontSizes.2')(props)}px;
    color: ${props => (0,esm/* getTextColor */.uu)('scratched')(props)};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    text-align: left;
  }

  ${ImageContent} {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border: ${props => (0,esm/* themeGet */.R)('borders.0')(props)};
    margin: 4px 7px 4px 0;

    ${LinkImage} {
      width: 100%;
      border-radius: 50%;
    }
  }
`;
const Container = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  flex-direction: column;
  align-items: center;

  ${({
  directionType
}) => directionType === 'column' && columnStyle}
`;
const TextComponent = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(() => ({
  color: 'base',
  fontSize: [0, 1, 2]
}))`
  text-align: center;
  line-height: ${props => (0,esm/* themeGet */.R)('lineHeights.plus')(props)}px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/HotLink/HotLink.js




const HotLink = ({
  item,
  onClick,
  directionType,
  imgLazyLoading
}) => {
  const {
    link,
    image,
    text,
    borderColor
  } = item;
  return /*#__PURE__*/react.createElement(Link, {
    href: link,
    onClick: e => onClick(e, item),
    "data-testid": "hotlink-link",
    borderColor: borderColor
  }, /*#__PURE__*/react.createElement(Container, {
    directionType: directionType,
    borderColor: borderColor,
    "data-testid": `title-${text}`
  }, /*#__PURE__*/react.createElement(ImageContent, null, /*#__PURE__*/react.createElement(LinkImage, {
    alt: text,
    src: image,
    lazy: imgLazyLoading
  })), /*#__PURE__*/react.createElement(TextComponent, null, text)));
};

HotLink.defaultProps = {
  item: {},
  onClick: () => {},
  directionType: 'row',
  imgLazyLoading: true
};
 false ? 0 : void 0;
/* harmony default export */ var HotLink_HotLink = (HotLink);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/HotLink/index.js


/***/ }),

/***/ 29869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ input; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Input/input.styles.js



const inputStyle = styled_components_browser_esm/* css */.iv`
  border: 1px solid;
  border-color: ${_ref => {
  let {
    hasError
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["hasError"]);

  return (0,esm/* getPaletteColor */.ow)(!hasError ? 'border.light' : 'error.base')(props);
}};
  border-radius: 4px;
  width: 100%;

  padding: ${(0,esm/* themeGet */.R)('space.2')}px;
  line-height: ${(0,esm/* themeGet */.R)('lineHeights.input')};
  font-size: ${(0,esm/* themeGet */.R)('fontSizes.1')}px;

  ::placeholder {
    color: ${(0,esm/* getTextColor */.uu)('light')};
  }
`;
const Line = styled_components_browser_esm/* default.input */.ZP.input`
  ${inputStyle}
`;
const Multiline = styled_components_browser_esm/* default.textarea.attrs */.ZP.textarea.attrs(props => ({
  rows: props.rows || '5',
  cols: props.cols || '40'
}))`
  ${inputStyle}
  resize: none;
  font-family: ${(0,esm/* themeGet */.R)('fontFamily')};
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Input/input.js





const Input = /*#__PURE__*/(0,react.forwardRef)((_ref, ref) => {
  let {
    children,
    value,
    onChange
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["children", "value", "onChange"]);

  const Component = props.multiline ? Multiline : Line;
  return /*#__PURE__*/react.createElement(Component, (0,esm_extends/* default */.Z)({
    ref: ref
  }, props, {
    value: value,
    onChange: e => onChange(e, value)
  }), children);
});
Input.defaultProps = {
  multiline: false,
  hasError: false,
  onChange: () => {}
};
 false ? 0 : void 0;
Input.displayName = 'Input';
/* harmony default export */ var input = (Input);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Input/index.js


/***/ }),

/***/ 81572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ item; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Item/item.styles.js






const Container = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(_ref => {
  let {
    justifyContent,
    centered
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["justifyContent", "centered"]);

  return Object.assign({
    width: '100%',
    alignItems: 'center',
    justifyContent: centered ? 'center' : justifyContent,
    flexWrap: 'wrap',
    gap: 2,
    px: 2
  }, !(props != null && props.scale) && {
    py: 2
  }, props);
})({
  textDecoration: 'none'
}, esm/* variant */.bU, esm/* scale */.bA);
const Title = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(_ref2 => {
  let {
    textAlign,
    centered,
    justifyContent
  } = _ref2,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, ["textAlign", "centered", "justifyContent"]);

  return Object.assign({
    forwardedAs: 'span',
    fontSize: 1,
    flex: centered || justifyContent !== 'space-between' ? 'unset' : 1,
    color: 'inherit',
    position: textAlign === 'center' ? 'absolute' : 'initial',
    transform: textAlign === 'center' ? 'translateX(-50%)' : 'initial',
    left: textAlign === 'center' ? '50%' : 'initial'
  }, props);
})``;
const Content = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(props => Object.assign({
  fontSize: 1,
  color: 'text.scratched',
  fontWeight: 'regular',
  lineHeight: 'display'
}, props))({
  flexBasis: '100%',
  textAlign: 'justify',
  textAlignLast: 'left'
});
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Item/item-description.js






const ItemDescription = _ref => {
  let {
    children
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["children"]);

  return /*#__PURE__*/react.createElement(Text/* default */.Z, (0,esm_extends/* default */.Z)({}, props, {
    "data-testid": "item-description"
  }), children);
};

 false ? 0 : void 0;
ItemDescription.defaultProps = {
  color: 'inherit',
  fontWeight: 'normal',
  display: 'block',
  as: 'small',
  fontSize: 0,
  mt: 1
};
ItemDescription.displayName = 'ItemDescription';
/* harmony default export */ var item_description = (ItemDescription);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Item/item-content.js






const ItemContent = _ref => {
  let {
    children
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["children"]);

  return /*#__PURE__*/react.createElement(Content, (0,esm_extends/* default */.Z)({}, props, {
    "data-testid": "item-content"
  }), children);
};

 false ? 0 : void 0;
ItemContent.displayName = 'ItemContent';
/* harmony default export */ var item_content = (ItemContent);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Item/item-header.js










const ItemHeader = _ref => {
  let {
    centered,
    description,
    content,
    endIcon,
    fill,
    fontSize,
    hint,
    onClick,
    startIcon,
    textAlign,
    title,
    ellipsis,
    as,
    titleAs,
    justifyContent
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["centered", "description", "content", "endIcon", "fill", "fontSize", "hint", "onClick", "startIcon", "textAlign", "title", "ellipsis", "as", "titleAs", "justifyContent"]);

  const children = react.Children.toArray(props == null ? void 0 : props.children);

  const buildIcon = icon => icon && typeof icon === 'string' ? /*#__PURE__*/react.createElement(build_esm/* Icon */.JO$, {
    name: icon,
    fill: fill,
    "data-testid": "item-icon"
  }) : icon;

  const buildHint = () => hint && typeof hint === 'string' ? /*#__PURE__*/react.createElement(Text/* default */.Z, {
    as: "label",
    fontSize: 1,
    fontWeight: "normal",
    "data-testid": "item-hint"
  }, hint) : hint;

  const buildDescription = () => description && typeof description === 'string' ? /*#__PURE__*/react.createElement(item_description, null, description) : description;

  const buildTitle = () => title && typeof title === 'string' ? /*#__PURE__*/react.createElement(Title, {
    fontSize: fontSize,
    textAlign: textAlign,
    centered: centered,
    "data-testid": "item-title",
    forwardedAs: titleAs
  }, title, buildDescription()) : title;

  const buildChildren = () => {
    const hasDescription = buildDescription();
    const ellipsisStyle = ellipsis ? {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      width: '100%'
    } : null;
    return hasDescription ? /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Title, {
      fontSize: fontSize,
      textAlign: textAlign,
      centered: centered,
      style: ellipsisStyle,
      "data-testid": "item-title",
      forwardedAs: titleAs
    }, children, hasDescription)) : /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(Title, {
      fontSize: fontSize,
      textAlign: textAlign,
      centered: centered,
      style: ellipsisStyle,
      "data-testid": "item-title",
      forwardedAs: titleAs,
      justifyContent: justifyContent
    }, children == null ? void 0 : children.filter(({
      type: {
        displayName
      } = {}
    }) => displayName !== 'ItemContent')));
  };

  const buildContent = () => {
    const contentAsChild = children == null ? void 0 : children.find(({
      type: {
        displayName
      } = {}
    }) => displayName === 'ItemContent');
    if (contentAsChild) return contentAsChild;
    return content ? /*#__PURE__*/react.createElement(item_content, null, content) : null;
  };

  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    forwardedAs: as,
    centered: centered,
    textAlign: textAlign,
    onClick: onClick,
    "data-testid": "item",
    justifyContent: justifyContent
  }, props), buildIcon(startIcon), buildTitle() || buildChildren(), buildHint() || buildIcon(endIcon), buildContent());
};

 false ? 0 : void 0;
ItemHeader.defaultProps = {
  title: '',
  children: null,
  justifyContent: 'space-between',
  startIcon: null,
  endIcon: null,
  hint: null,
  centered: false,
  fill: 'currentColor',
  ellipsis: false
};
/* harmony default export */ var item_header = (ItemHeader);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Item/item.js








const Item = /*#__PURE__*/(0,react.forwardRef)((_ref, ref) => {
  let {
    as,
    onClick
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["as", "onClick"]);

  const children = react.Children.toArray(props == null ? void 0 : props.children);
  const useOnlyContainer = children == null ? void 0 : children.find(({
    type: {
      displayName
    } = {}
  }) => displayName == null ? void 0 : displayName.includes('ItemHeader'));
  return useOnlyContainer ? /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    ref: ref,
    forwardedAs: as,
    onClick: onClick,
    "data-testid": "item-container"
  }, props), children) : /*#__PURE__*/react.createElement(item_header, (0,esm_extends/* default */.Z)({
    ref: ref,
    as: as,
    onClick: onClick
  }, props));
});
 false ? 0 : void 0;
Item.defaultProps = {
  title: '',
  children: null
};
Item.Content = item_content;
Item.Description = item_description;

Item.Header = props => /*#__PURE__*/react.createElement(item_header, (0,esm_extends/* default */.Z)({
  px: 0,
  py: 0
}, props));

Item.Header.displayName = 'ItemHeader';
Item.displayName = 'Item';
/* harmony default export */ var item = (Item);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Item/index.js


/***/ }),

/***/ 66228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ij": function() { return /* reexport */ schemas/* breadcrumbSchema */.ij; },
  "ZP": function() { return /* reexport */ json_ld; },
  "I1": function() { return /* reexport */ schemas/* faqSchema */.I1; },
  "Iy": function() { return /* reexport */ schemas/* productSchema */.Iy; }
});

// UNUSED EXPORTS: aggregatingRatingSchema, offerSchema, reviewSchema

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/JsonLD/schemas/index.js + 11 modules
var schemas = __webpack_require__(93088);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/JsonLD/json-ld.js


/**
 * [NO VISUAL] Use the `JsonLD` component to insert SEO structured data inside script tag.
 */

const JsonLD = ({
  type,
  schema
}) => {
  const json = Array.isArray(schema) ? {
    '@context': 'https://schema.org/',
    '@graph': schema
  } : Object.assign({
    '@context': 'https://schema.org/',
    '@type': type
  }, schema);
  return /*#__PURE__*/react.createElement("script", {
    type: "application/ld+json",
    "data-testid": "jsonld-script",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(json)
    }
  });
};

 false ? 0 : void 0;
/* harmony default export */ var json_ld = (JsonLD);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/JsonLD/index.js



/***/ }),

/***/ 93088:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H9": function() { return /* reexport */ aggregate_rating; },
  "ij": function() { return /* reexport */ breadcrumb; },
  "I1": function() { return /* reexport */ faq; },
  "NI": function() { return /* reexport */ schemas_offer; },
  "Iy": function() { return /* reexport */ product; },
  "$5": function() { return /* reexport */ schemas_review; }
});

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/JsonLD/schemas/aggregate-rating.js
const aggregateRating = (data, productRating) => {
  var _productRating$genera, _data$score, _productRating$genera2, _productRating$genera3, _data$count, _productRating$genera4, _productRating$genera5;

  if ((!data || Object.keys(data).length === 0 || (data == null ? void 0 : data.count) === 0) && (!productRating || !(productRating != null && productRating.general) || Object.keys(productRating == null ? void 0 : productRating.general).length === 0 || (productRating == null ? void 0 : (_productRating$genera = productRating.general) == null ? void 0 : _productRating$genera.reviewCount) === 0)) return null;
  return {
    '@type': 'AggregateRating',
    ratingValue: (data == null ? void 0 : data.count) > 0 ? data == null ? void 0 : (_data$score = data.score) == null ? void 0 : _data$score.toString() : productRating == null ? void 0 : (_productRating$genera2 = productRating.general) == null ? void 0 : (_productRating$genera3 = _productRating$genera2.rating) == null ? void 0 : _productRating$genera3.toFixed(0),
    reviewCount: (data == null ? void 0 : data.count) > 0 ? data == null ? void 0 : (_data$count = data.count) == null ? void 0 : _data$count.toString() : productRating == null ? void 0 : (_productRating$genera4 = productRating.general) == null ? void 0 : (_productRating$genera5 = _productRating$genera4.reviewCount) == null ? void 0 : _productRating$genera5.toString()
  };
};

/* harmony default export */ var aggregate_rating = (aggregateRating);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/constants/index.js
var constants = __webpack_require__(12468);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/JsonLD/schemas/breadcrumb.js


const breadcrumbSchema = (data, domain = constants/* MAGALU_DOMAIN */.RW) => {
  if (!data || data.length === 0) return {};
  const magalu = [{
    name: 'magalu.com',
    position: 1,
    url: ''
  }];
  const breadcrumbList = [...magalu, ...data];
  const finalList = breadcrumbList.map(item => ({
    '@type': 'ListItem',
    position: item.position,
    item: {
      '@id': `${domain}${item == null ? void 0 : item.url}`,
      name: item.name
    }
  }));
  return {
    itemListElement: finalList
  };
};

/* harmony default export */ var breadcrumb = (breadcrumbSchema);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/JsonLD/schemas/faq.js
const faqSchema = data => {
  if (!data || Object.keys(data).length === 0 || data.count === 0) return null;
  const finalList = data.filter(item => item.question && item.answer).map(item => ({
    '@type': 'Question',
    name: item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.answer
    }
  }));
  return {
    mainEntity: finalList
  };
};

/* harmony default export */ var faq = (faqSchema);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/JsonLD/schemas/offer.js
const offerSchema = (data, urlProduct) => {
  var _data$price, _data$price2, _data$price3, _data$price4;

  if (!data || Object.keys(data).length === 0 || !urlProduct || !data.price || !(data != null && (_data$price = data.price) != null && _data$price.bestPrice) && !(data != null && (_data$price2 = data.price) != null && _data$price2.price)) return null;
  return {
    '@type': 'Offer',
    price: (data == null ? void 0 : (_data$price3 = data.price) == null ? void 0 : _data$price3.bestPrice) || (data == null ? void 0 : (_data$price4 = data.price) == null ? void 0 : _data$price4.price),
    priceCurrency: 'BRL',
    availability: 'http://schema.org/InStock',
    url: (data == null ? void 0 : data.offer) || urlProduct
  };
};

/* harmony default export */ var schemas_offer = (offerSchema);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/JsonLD/helpers/transformDateString.js
const transformDateString = data => {
  const date = new Date(data);
  return data ? `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}` : '';
};

/* harmony default export */ var helpers_transformDateString = (transformDateString);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/JsonLD/helpers/constructObjectDefault.js



const constructObjectDefault = (product, productRating, domain) => {
  var _product$image, _product$brand;

  const urlProduct = `${domain}${product == null ? void 0 : product.url}`;
  const aggregateContent = aggregate_rating(product.rating, productRating);
  const aggregateRating = !aggregateContent ? {} : {
    aggregateRating: aggregateContent
  };
  const offer = schemas_offer(product, urlProduct);
  const offerContent = !offer ? {} : {
    offers: offer
  };
  return Object.assign({
    '@context': 'https://schema.org',
    '@type': 'Product'
  }, aggregateRating, {
    name: product.title,
    image: (_product$image = product.image) == null ? void 0 : _product$image.replace('{w}', constants/* productImageSizes.width */.w.width).replace('{h}', constants/* productImageSizes.height */.w.height),
    brand: (_product$brand = product.brand) == null ? void 0 : _product$brand.label,
    sku: product.id,
    description: product.description || product.title
  }, offerContent);
};

/* harmony default export */ var helpers_constructObjectDefault = (constructObjectDefault);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/JsonLD/helpers/transformCategoryString.js
const transformCategoryString = (category = '', subcategory = '') => {
  return category ? `${category} > ${subcategory}` : '';
};

/* harmony default export */ var helpers_transformCategoryString = (transformCategoryString);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/JsonLD/helpers/constructObjectProduct.js



const constructObjectProduct = (product, productRating) => {
  var _productRating$userRe, _productRating$userRe2, _product$attributes, _product$category, _product$subcategory;

  const reviewContent = productRating == null ? void 0 : (_productRating$userRe = productRating.userReviews) == null ? void 0 : (_productRating$userRe2 = _productRating$userRe.items) == null ? void 0 : _productRating$userRe2.map(el => schemas_review(el)).filter(el => el);
  const reviewObject = !reviewContent ? {} : {
    review: reviewContent
  };
  const color = product == null ? void 0 : (_product$attributes = product.attributes) == null ? void 0 : _product$attributes.find(el => el.type === 'color');
  return Object.assign({
    description: product.description || product.title,
    category: helpers_transformCategoryString(product == null ? void 0 : (_product$category = product.category) == null ? void 0 : _product$category.name, product == null ? void 0 : (_product$subcategory = product.subcategory) == null ? void 0 : _product$subcategory.name),
    color: color == null ? void 0 : color.current,
    itemCondition: 'https://schema.org/NewCondition',
    sku: product == null ? void 0 : product.id
  }, reviewObject);
};

/* harmony default export */ var helpers_constructObjectProduct = (constructObjectProduct);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/JsonLD/helpers/index.js




;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/JsonLD/schemas/product.js



const productSchema = ({
  product = {},
  productRating = {},
  isList = false
}, domain = constants/* MAGALU_DOMAIN */.RW) => {
  if (!product || Object.keys(product).length === 0) return {};
  const objectDefault = helpers_constructObjectDefault(product, productRating, domain);
  const objectProductPage = isList ? {} : helpers_constructObjectProduct(product, productRating);
  return Object.assign({}, objectDefault, objectProductPage);
};

/* harmony default export */ var product = (productSchema);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/JsonLD/schemas/review.js


const review = data => {
  var _data$userData;

  if (!data || Object.keys(data).length === 0 || !data.userData || !((_data$userData = data.userData) != null && _data$userData.name)) return null;
  return {
    '@type': 'Review',
    author: {
      '@type': 'Person',
      name: data.userData.name
    },
    datePublished: helpers_transformDateString(data.submissionDate),
    reviewBody: data.description,
    name: data.title,
    reviewRating: {
      '@type': 'Rating',
      bestRating: '5',
      ratingValue: data.rating.toString(),
      worstRating: '1'
    }
  };
};

/* harmony default export */ var schemas_review = (review);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/JsonLD/schemas/index.js







/***/ }),

/***/ 91785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ lazy_load_component; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(33279);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/LazyLoadComponent/lazy-load-component.js





const defaultDelay = 500;
const defaultThreshold = 0;
const defaultRootMargin = '0px 0px 250px';

const LazyLoadComponent = ({
  children,
  options,
  layout
}) => {
  const {
    delay = defaultDelay,
    threshold = defaultThreshold,
    rootMargin = defaultRootMargin
  } = options || {};
  const [isVisible, setIsVisible] = (0,react.useState)(false);
  const [temporaryProps, addTemporaryProps] = (0,react.useState)(layout);
  const [elemRef, inView] = (0,react_intersection_observer_m/* useInView */.YD)({
    triggerOnce: true,
    threshold,
    rootMargin
  });
  (0,react.useEffect)(() => {
    let timer;

    if (inView && !isVisible) {
      setIsVisible(true);
      timer = setTimeout(() => addTemporaryProps({}), delay);
    }

    return () => timer && clearTimeout(timer);
  }, [inView]);
  return /*#__PURE__*/react.createElement(Box/* default */.Z, (0,esm_extends/* default */.Z)({}, temporaryProps, {
    "data-testid": "lazyload-container",
    ref: elemRef
  }), isVisible && children);
};

 false ? 0 : void 0;
LazyLoadComponent.defaultProps = {
  children: undefined,
  layout: {},
  options: {
    delay: defaultDelay,
    rootMargin: defaultRootMargin,
    threshold: defaultThreshold
  }
};
/* harmony default export */ var lazy_load_component = (LazyLoadComponent);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/LazyLoadComponent/index.js


/***/ }),

/***/ 10200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Link_link; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@styled-system/prop-types/dist/index.esm.js
var index_esm = __webpack_require__(21302);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var dist_index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/link.styles.js




const typeReset = {
  a: styled_components_browser_esm/* css */.iv`
    text-decoration: none;
  `,
  button: styled_components_browser_esm/* css */.iv`
    font-size: inherit;
    font-family: inherit;
    border: 0;
    margin: 0;
    overflow: visible;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  `
}; // Using .attrs to define default props
// Docs: https://styled-components.com/docs/api#attrs

const Link = styled_components_browser_esm/* default.a.attrs */.ZP.a.attrs(_ref => {
  let {
    color
  } = _ref,
      otherProps = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["color"]);

  return Object.assign({
    color: color || 'text.base',
    fontSize: 1
  }, otherProps);
})`
  cursor: pointer;

  ${({
  as
}) => typeReset[as]}
  ${({
  textAlign
}) => textAlign ? styled_components_browser_esm/* css */.iv`
          display: block;
        ` : styled_components_browser_esm/* css */.iv`
          ${{
  display: 'inline-flex'
}}
          ${dist_index_esm/* flexbox */.GQ}
          align-items: center;
        `}
  ${({
  underline
}) => underline && styled_components_browser_esm/* css */.iv`
      text-decoration: underline;
    `}
  ${({
  hover
}) => hover && styled_components_browser_esm/* css */.iv`
      &:hover {
        text-decoration: ${props => props != null && props.underlineOnHover ? 'underline' : !(props != null && props.underline) && 'none'};
        color: ${props => props.colorOnHover || (0,esm/* getPaletteColor */.ow)(props.color)(props) || props.color};
      }
    `}
  ${dist_index_esm/* background */.Oq}
  ${dist_index_esm/* border */.Cg}
  ${dist_index_esm/* layout */.bK}
  ${esm/* color */.$_}
  ${dist_index_esm/* space */.Dh}
  ${dist_index_esm/* textAlign */.yd}
  ${dist_index_esm/* typography */.cp}
  ${dist_index_esm/* grid */.eC}
  ${esm/* gap */.SG}
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/link.js






const link_Link = /*#__PURE__*/(0,react.forwardRef)((_ref, ref) => {
  let {
    children
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["children"]);

  const type = props != null && props.href ? 'a' : 'button';
  return /*#__PURE__*/react.createElement(Link, (0,esm_extends/* default */.Z)({
    ref: ref,
    "data-testid": "link",
    as: type
  }, props), children);
});
 false ? 0 : void 0;
link_Link.defaultProps = {
  hover: true,
  underline: false,
  underlineOnHover: true,
  bg: 'transparent'
};
link_Link.displayName = 'Link';
/* harmony default export */ var Link_link = (link_Link);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js


/***/ }),

/***/ 15566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Logo_Logo; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/LogoParceiroMagalu/index.js + 2 modules
var LogoParceiroMagalu = __webpack_require__(23076);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Logo/Logo.js





const Logo = ({
  storeName,
  width,
  height,
  src,
  alt,
  prefix
}) => {
  if (storeName) {
    return /*#__PURE__*/react.createElement(LogoParceiroMagalu/* default */.Z, {
      name: storeName,
      prefix: prefix
    });
  }

  if (src) {
    return /*#__PURE__*/react.createElement("img", {
      id: "logo",
      width: `${width}px`,
      src: src,
      alt: alt
    });
  }

  return /*#__PURE__*/react.createElement(esm/* LogoMagalu */.ZGh, {
    id: "logo",
    color: "#fff",
    width: width,
    height: height,
    viewBox: "0 0 60 13",
    titleAccess: "Logo Magalu"
  });
};

Logo.defaultProps = {
  storeName: undefined,
  prefix: undefined,
  width: 87,
  height: 19,
  src: '',
  alt: ''
};
 false ? 0 : void 0;
/* harmony default export */ var Logo_Logo = (/*#__PURE__*/(0,react.memo)(Logo));
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Logo/index.js


/***/ }),

/***/ 23076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ LogoParceiroMagalu_LogoParceiroMagalu; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/LogoParceiroMagalu/LogoParceiroMagalu.styles.js


const LogoContainer = styled_components_browser_esm/* default.div */.ZP.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  color: ${props => (0,esm/* getPaletteColor */.ow)('primary.text')(props)};
`;
const LogoPrefix = styled_components_browser_esm/* default.strong */.ZP.strong`
  color: ${props => (0,esm/* getPaletteColor */.ow)('primary.dark')(props)};
  margin-right: 2px;
`;
const LogoText = styled_components_browser_esm/* default.span */.ZP.span`
  display: block;
  margin-bottom: 5px;
  font-size: ${props => (0,esm/* themeGet */.R)('fontSizes.4')(props)}px;
  font-weight: ${props => (0,esm/* themeGet */.R)('fontWeights.bold')(props)};
  line-height: ${props => (0,esm/* themeGet */.R)('lineHeights.fontSize')(props)};
`;
const LogoLegend = styled_components_browser_esm/* default.div */.ZP.div`
  font-size: ${props => (0,esm/* themeGet */.R)('fontSizes.0')(props)}px;
  margin-bottom: 5px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/LogoParceiroMagalu/LogoParceiroMagalu.js



const FIRST_INDEX = 0;

const LogoParceiroMagalu = ({
  name,
  prefix
}) => {
  const cleanName = name.indexOf(prefix) === FIRST_INDEX ? name.replace(prefix, '') : name;
  return /*#__PURE__*/react.createElement(LogoContainer, null, /*#__PURE__*/react.createElement(LogoText, null, /*#__PURE__*/react.createElement(LogoPrefix, null, prefix), cleanName), /*#__PURE__*/react.createElement(LogoLegend, null, "uma loja parceira do ", /*#__PURE__*/react.createElement("strong", null, "Magalu")));
};

LogoParceiroMagalu.defaultProps = {
  prefix: 'magazine'
};
 false ? 0 : void 0;
/* harmony default export */ var LogoParceiroMagalu_LogoParceiroMagalu = (/*#__PURE__*/(0,react.memo)(LogoParceiroMagalu));
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/LogoParceiroMagalu/index.js


/***/ }),

/***/ 54934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ menu_item; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/MenuItem/menu-item.styles.js




const variations = {
  primary: styled_components_browser_esm/* css */.iv`
    background-color: ${props => (0,build_esm/* getBackgroundColor */.dF)('primary')(props)};
    color: ${props => (0,build_esm/* getTextColor */.uu)('lightest')(props)};
    font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.2')(props)}px;
  `,
  secondary: styled_components_browser_esm/* css */.iv`
    color: ${props => (0,build_esm/* getTextColor */.uu)('light')(props)};
  `
};
const Container = styled_components_browser_esm/* default.div */.ZP.div`
  ${({
  noBorder
}) => !noBorder && styled_components_browser_esm/* css */.iv`
      border-bottom: 1px solid #ededed;
    `}
  text-decoration: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 4px 12px 12px;
  ${props => variations[props.variation]}
`;
const ContainerBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)`
  flex: 1;
`;
const TextMenu = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs(({
  isLink,
  chevronRight
}) => ({
  fontSize: 1,
  fontWeight: isLink || !chevronRight ? 'regular' : 'medium'
}))`
  ${props => variations[props.variation]}
  line-height: ${props => (0,build_esm/* themeGet */.R)('lineHeights.tall')(props)}px;
  padding-left: ${props => props.icon ? '8px' : '0px'};
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/MenuItem/menu-item.js






/**
 * A component for setting items menu.
 */

function MenuItem(_ref) {
  let {
    icon,
    text,
    testId,
    onClick
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["icon", "text", "testId", "onClick"]);

  const {
    chevronRight,
    href,
    variation
  } = props;
  const iconColor = variation === 'primary' ? '#FFF' : '#999';
  const typeDiv = href ? 'a' : 'div';
  const label = Array.isArray(text) ? text[0] : text || '';
  const otherLabels = Array.isArray(text) ? text.slice(1) : [];
  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    "data-testid": testId,
    as: typeDiv,
    href: href,
    onClick: onClick
  }, props), icon && /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    name: icon,
    color: icon.startsWith('Category') ? '#0086FF' : iconColor
  }), /*#__PURE__*/react.createElement(ContainerBox, null, /*#__PURE__*/react.createElement(TextMenu, (0,esm_extends/* default */.Z)({
    isLink: !!href,
    icon: icon
  }, props), label), otherLabels.map(item => /*#__PURE__*/react.createElement(TextMenu, {
    key: item,
    isLink: !!href,
    icon: icon,
    variation: "secondary"
  }, item))), chevronRight && /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
    name: "ChevronRight",
    color: iconColor
  }));
}

 false ? 0 : void 0;
MenuItem.defaultProps = {
  chevronRight: true,
  href: null,
  icon: null,
  testId: '',
  variation: '',
  onClick: () => {}
};
/* harmony default export */ var menu_item = (MenuItem);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/MenuItem/index.js


/***/ }),

/***/ 97851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ numbered_button; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/NumberedButton/numbered-button.styles.js


const Container = styled_components_browser_esm/* default.div */.ZP.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
const ImageBtn = styled_components_browser_esm/* default.button */.ZP.button`
  position: relative;
  width: 100%;
  height: 100%;

  max-width: ${({
  maxWidth
}) => `${maxWidth}px`};
  max-height: ${({
  maxHeight
}) => `${maxHeight}px`};
  border: none;
  cursor: pointer;

  background: none;

  transition: all 0.2s ease-in-out;

  &:disabled {
    opacity: 0.5;
  }

  &:hover:not(:disabled) {
    transform: scale(1.1);
  }
`;
const Counter = styled_components_browser_esm/* default.div */.ZP.div`
  ${esm/* color */.$_}

  position: absolute;
  right: 0;
  bottom: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  height: 28px;
  width: 28px;
  border-radius: 50%;
  border: 3px solid ${({
  borderColor
}) => borderColor};

  font-size: 12px;
  font-weight: bold;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/NumberedButton/numbered-button.js




const NumberedButton = ({
  children,
  amount = 0,
  nullable = true,
  truncateAmountThreshold,
  maxWidth = 60,
  maxHeight = 46,
  backgroundColor = '#ccc',
  counterColor = '#fff',
  fontColor = '#000',
  onClick
}) => {
  const greaterThanThreshold = () => truncateAmountThreshold && amount > truncateAmountThreshold;

  return /*#__PURE__*/react.createElement(Container, null, /*#__PURE__*/react.createElement(ImageBtn, {
    maxWidth,
    maxHeight,
    onClick
  }, children, (amount || nullable) && /*#__PURE__*/react.createElement(Counter, {
    "data-testid": "numbered-btn-counter",
    bg: counterColor,
    borderColor: backgroundColor,
    color: fontColor
  }, greaterThanThreshold() ? `${truncateAmountThreshold}+` : amount)));
};

 false ? 0 : void 0;
/* harmony default export */ var numbered_button = (NumberedButton);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/NumberedButton/index.js


/***/ }),

/***/ 26527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PageLoading_PageLoading; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/PageLoading/styled.js


const Container = styled_components_browser_esm/* default.div */.ZP.div`
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  position: fixed;
  backdrop-filter: blur(4px);
  z-index: ${props => (0,build_esm/* themeGet */.R)('zIndices.4')(props)};

  display: flex;
  justify-content: center;
  align-items: center;

  ::before {
    content: '';
    width: 100%;
    height: 100%;
    background-color: ${(0,build_esm/* getPaletteColor */.ow)('background.lighter')};
    opacity: 0.7;
    position: absolute;
    z-index: -1;
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/PageLoading/PageLoading.js




const PageLoading = () => /*#__PURE__*/react.createElement(Container, null, /*#__PURE__*/react.createElement(esm/* Icon */.JO$, {
  name: "AnimatedLoadingColorful2",
  width: 50,
  height: 50
}));

/* harmony default export */ var PageLoading_PageLoading = (PageLoading);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/PageLoading/index.js


/***/ }),

/***/ 7121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ popper; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-popper/lib/esm/usePopper.js + 1 modules
var usePopper = __webpack_require__(35741);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Popper/popper.styles.js




const Container = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(props => Object.assign({}, props))`
  border-radius: ${props => (0,esm/* themeGet */.R)('radii.default')(props)};
  background-color: ${props => props.backgroundColor || 'white'};
  animation: ${utils/* fadeIn */.Ji} 0.2s ease-in;

  #arrow {
    position: absolute;
    width: 16px;
    height: 16px;
    &:after {
      content: ' ';
      background-color: ${props => props.backgroundColor || 'white'};
      position: absolute;
      width: 16px;
      height: 16px;
      transform: rotate(45deg);
      ${esm/* color */.$_}
    }
  }

  &[data-popper-placement^='bottom'] > #arrow {
    top: -8px;
    :after {
      left: 0;
    }
  }

  &[data-popper-placement^='top'] > #arrow {
    bottom: -8px;
    :after {
      left: 0;
    }
  }

  &[data-popper-placement^='right'] > #arrow {
    left: -6px;
  }

  &[data-popper-placement^='left'] > #arrow {
    right: -6px;
  }

  ${index_esm/* space */.Dh}
  ${index_esm/* typography */.cp}
  ${esm/* color */.$_}
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Popper/popper.js








function Popper(_ref) {
  let {
    backgroundColor,
    children,
    parentRef,
    placement = 'bottom',
    visible
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["backgroundColor", "children", "parentRef", "placement", "visible"]);

  const [arrowRef, setArrowRef] = (0,react.useState)(null);
  const popperRef = (0,react.useRef)(null);
  const {
    styles,
    attributes
  } = (0,usePopper/* usePopper */.D)(parentRef.current, popperRef.current, {
    placement,
    modifiers: [{
      name: 'arrow',
      options: {
        element: arrowRef
      }
    }, {
      name: 'offset',
      options: {
        offset: [0, 10]
      }
    }, {
      name: 'flip',
      options: {
        flipVariations: false
      }
    }]
  });
  return /*#__PURE__*/react.createElement(react.Fragment, null, visible ? /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    "data-testid": "popper-container",
    ref: popperRef,
    style: styles.popper
  }, attributes.popper, {
    backgroundColor: backgroundColor
  }, props), /*#__PURE__*/react.createElement("div", {
    ref: setArrowRef,
    style: styles.arrow,
    id: "arrow"
  }), /*#__PURE__*/react.createElement(Box/* default */.Z, {
    "data-testid": "popper-children-container",
    m: 1
  }, children)) : null);
}

 false ? 0 : void 0;
/* harmony default export */ var popper = (Popper);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Popper/index.js


/***/ }),

/***/ 75851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ portal; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Portal/portal.js



const Portal = ({
  id,
  children
}) => {
  if (typeof window !== 'object') {
    return react.Fragment;
  } // get element already in DOM or create another with the id


  const node = (0,react.useRef)(document.getElementById(id) || document.createElement('div'));
  const [dynamic] = (0,react.useState)(!node.current.parentElement);
  (0,react.useEffect)(() => {
    if (dynamic) {
      node.current.id = id;
      if (document.querySelector('main')) document.querySelector('main').appendChild(node.current);else document.body.appendChild(node.current);
    }

    return () => {
      if (dynamic && node.current.parentElement) {
        node.current.parentElement.removeChild(node.current);
      }
    };
  }, [id]);
  return /*#__PURE__*/(0,react_dom.createPortal)(children, node.current);
};

/* harmony default export */ var portal = (/*#__PURE__*/(0,react.memo)(Portal));
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Portal/index.js


/***/ }),

/***/ 70715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Radio_radio; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Grid/index.js + 2 modules
var Grid = __webpack_require__(8341);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Radio/radio.styles.js



const Label = (0,styled_components_browser_esm/* default */.ZP)(Grid/* default */.Z).attrs(props => Object.assign({
  forwardedAs: 'label',
  color: 'text.base',
  gridTemplateColumns: 'min-content auto',
  gridGap: 3,
  py: 3
}, props))`
  cursor: pointer;
  align-items: center;
`;
const Input = styled_components_browser_esm/* default.input.attrs */.ZP.input.attrs(props => Object.assign({
  type: 'radio'
}, props))`
  pointer-events: ${({
  pointerNone
}) => pointerNone ? `none` : `auto`};
  appearance: none;
  background: transparent;
  width: 20px;
  height: 20px;
  border: ${(0,esm/* themeGet */.R)('borders.1')};
  border-radius: ${(0,esm/* themeGet */.R)('radii.circle')};
  cursor: pointer;

  &:checked {
    border-color: ${(0,esm/* getBackgroundColor */.dF)('primary')};

    &:before {
      content: '';
      display: block;
      position: relative;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 10px;
      height: 10px;
      border-radius: ${(0,esm/* themeGet */.R)('radii.circle')};
      background: ${(0,esm/* getBackgroundColor */.dF)('primary')};
    }
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Radio/radio.js






const Radio = _ref => {
  let {
    pointerNone,
    label,
    onChange
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["pointerNone", "label", "onChange"]);

  const input = /*#__PURE__*/react.createElement(Input, (0,esm_extends/* default */.Z)({
    pointerNone: pointerNone
  }, props, {
    onChange: onChange,
    "data-testid": "radio-input"
  }));
  return label ? /*#__PURE__*/react.createElement(Label, (0,esm_extends/* default */.Z)({}, props, {
    "data-testid": "radio"
  }), input, label) : input;
};

 false ? 0 : void 0;
Radio.defaultProps = {
  fontSize: 1,
  pointerNone: ''
};
/* harmony default export */ var Radio_radio = (Radio);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Radio/index.js


/***/ }),

/***/ 7029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ responsive_image; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/constants/index.js
var constants = __webpack_require__(12468);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/responsive-image.styles.js



const Image = styled_components_browser_esm/* default.img */.ZP.img`
  width: 100%;
  height: inherit;
  object-fit: ${({
  objectFit
}) => objectFit || 'contain'};
  ${index_esm/* position */.FK}
  ${index_esm/* space */.Dh}
  ${index_esm/* layout */.bK}
  ${index_esm/* border */.Cg}
  ${esm/* cursor */.oc}
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/responsive-image.js







const ResponsiveImage = _ref => {
  let {
    src,
    srcSetDensity,
    imageWidth,
    imageHeight,
    width,
    height,
    lazy
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["src", "srcSetDensity", "imageWidth", "imageHeight", "width", "height", "lazy"]);

  if (!src) return /*#__PURE__*/react.createElement(react.Fragment, null);
  const imgProps = Object.assign({}, props, {
    width: imageWidth,
    height: imageHeight,
    src: src.replace('{w}', width).replace('{h}', height)
  });
  const srcSet = srcSetDensity.map(density => {
    const item = src.replace('{w}', width * density).replace('{h}', height * density);
    const targetDensity = density > 1 ? ` ${density}x` : '';
    return `${item}${targetDensity}`;
  }).join(', ');
  if (srcSet) imgProps.srcSet = srcSet;
  if (lazy) imgProps.loading = 'lazy';
  return /*#__PURE__*/react.createElement(Image, (0,esm_extends/* default */.Z)({
    "data-testid": "image"
  }, imgProps));
};

 false ? 0 : void 0;
ResponsiveImage.defaultProps = {
  height: constants/* productImageSizes.height */.w.height,
  lazy: true,
  src: '',
  srcSetDensity: [],
  width: constants/* productImageSizes.width */.w.width,
  imageWidth: '',
  imageHeight: ''
};
/* harmony default export */ var responsive_image = (ResponsiveImage);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js


/***/ }),

/***/ 73002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Select_select; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Select/select.styles.js



const Container = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)`
  display: flex;
  align-items: center;
  cursor: pointer;

  label {
    margin-right: ${props => (0,build_esm/* themeGet */.R)('space.2')(props)}px;

    ${({
  desktopMode
}) => desktopMode && styled_components_browser_esm/* css */.iv`
        font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
      `};
  }

  select {
    appearance: none;
    display: block;
    background-color: ${props => (0,build_esm/* themeGet */.R)('colors.white')(props)};
    cursor: pointer;
    border: 1px solid ${props => (0,build_esm/* getBorderColor */.kJ)('base')(props)};
    border-radius: ${props => (0,build_esm/* themeGet */.R)('radii.default')(props)};

    ${({
  desktopMode
}) => desktopMode ? styled_components_browser_esm/* css */.iv`
            font-size: ${props => (0,build_esm/* themeGet */.R)('fontSizes.1')(props)}px;
            padding: 8px 32px 8px 12px;
          ` : styled_components_browser_esm/* css */.iv`
            width: 100%;
            padding: 16px 32px 16px 12px;
            border-radius: 4px;
          `};

    &:focus {
      outline: none;
      background: ${props => (0,build_esm/* themeGet */.R)('baseColors.wildsand.base')(props)};
    }
    ::-ms-expand {
      display: none;
    }
  }

  svg {
    outline: none;
    pointer-events: none;

    flex: 0 0 auto;
    margin-left: -32px;
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Select/select.js






function Select(_ref) {
  let {
    id,
    textLabel,
    options,
    onChange
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["id", "textLabel", "options", "onChange"]);

  const selected = options.find(option => option.selected);
  return /*#__PURE__*/react.createElement(Container, props, textLabel && /*#__PURE__*/react.createElement("label", {
    htmlFor: `select-${id}`,
    "data-testid": "select-label"
  }, textLabel), /*#__PURE__*/react.createElement("select", {
    id: `select-${id}`,
    onChange: e => onChange(e.target.value),
    value: selected == null ? void 0 : selected.value,
    "data-testid": `select-${id}`
  }, options == null ? void 0 : options.map(item => /*#__PURE__*/react.createElement("option", {
    key: item.value,
    selected: item.selected,
    value: item.value,
    "data-testid": "select-option"
  }, item.label))), /*#__PURE__*/react.createElement(esm/* ChevronDown */._ME, {
    width: 20,
    height: 20
  }));
}

Select.defaultProps = {
  desktopMode: false,
  onChange: () => {},
  options: []
};
 false ? 0 : void 0;
/* harmony default export */ var Select_select = (Select);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Select/index.js


/***/ }),

/***/ 76328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ select_rating; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/SelectRating/select-rating.styles.js

const ReviewInput = styled_components_browser_esm/* default.input */.ZP.input`
  height: 0;
  width: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/SelectRating/select-rating.js








const scores = [1, 2, 3, 4, 5];
const scoresMap = {
  1: 'uma',
  2: 'duas',
  3: 'três',
  4: 'quatro',
  5: 'cinco'
};
const SelectRating = /*#__PURE__*/(0,react.forwardRef)((_ref, ref) => {
  let {
    onChange,
    emptyOutline,
    showLabel,
    labelOptions,
    value,
    name
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["onChange", "emptyOutline", "showLabel", "labelOptions", "value", "name"]);

  const [rating, setRating] = (0,react.useState)(value);
  const currentIcon = emptyOutline ? 'StarOutline' : 'Star';
  const evaluation = labelOptions[rating] || '';
  (0,react.useEffect)(() => {
    setRating(value);
    return () => setRating(0);
  }, [value]);

  const getColor = score => {
    if (rating >= score || emptyOutline) {
      return 'stars.base';
    }

    return 'stars.disabled';
  };

  return /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/react.createElement(Flex/* default */.Z, {
    ref: ref,
    "data-testid": "select-rating",
    justifyContent: "start",
    role: "radiogroup",
    onMouseLeave: () => setRating(value)
  }, scores.map(score => /*#__PURE__*/react.createElement(react.Fragment, {
    key: score
  }, /*#__PURE__*/react.createElement(ReviewInput, {
    type: "radio",
    name: name,
    value: score,
    id: `${name}${score}`,
    onChange: () => onChange({
      target: {
        value: score
      }
    })
  }), /*#__PURE__*/react.createElement("label", {
    htmlFor: `${name}${score}`
  }, /*#__PURE__*/react.createElement(esm/* Icon */.JO$, (0,esm_extends/* default */.Z)({
    name: rating >= score ? 'Star' : currentIcon,
    cursor: "pointer",
    color: getColor(score),
    onMouseOver: () => setRating(score),
    "aria-label": `${scoresMap[score]} ${score === 1 ? 'estrela' : 'estrelas'}`,
    onClick: () => onChange({
      target: {
        value: score
      }
    })
  }, props)))))), showLabel && /*#__PURE__*/react.createElement(Text/* default */.Z, {
    fontSize: [1, 2],
    minWidth: 80,
    textAlign: "center",
    fontWeight: "medium"
  }, evaluation));
});
SelectRating.defaultProps = {
  emptyOutline: false,
  showLabel: false,
  value: '',
  name: 'rating',
  labelOptions: {
    1: 'Péssimo',
    2: 'Ruim',
    3: 'Regular',
    4: 'Bom',
    5: 'Excelente'
  }
};
 false ? 0 : void 0;
SelectRating.displayName = 'SelectRating';
/* harmony default export */ var select_rating = (SelectRating);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/SelectRating/index.js


/***/ }),

/***/ 85737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ strip; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Strip/strip.styles.js

const StripMultiColors = styled_components_browser_esm/* default.hr */.ZP.hr`
  float: left;
  height: ${({
  size
}) => `${size}px`};
  position: ${({
  position
}) => position};
  width: 100%;
  overflow: hidden;
  border: none;
  background-image: linear-gradient(
    to right,
    #ffff4a 0,
    #fcd000 4%,
    #ffc112 8%,
    #ffc112 11%,
    #ff8a00 16%,
    #ff5f5f 22%,
    #ff253a 28%,
    #ff37a8 37%,
    #c739ff 49%,
    #a400e1 56%,
    #2eceff 72%,
    #0086ff 80%,
    #72f772 94%,
    #00d604
  );
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Strip/strip.js





const Strip = props => /*#__PURE__*/react.createElement(StripMultiColors, (0,esm_extends/* default */.Z)({
  "data-testid": "strip"
}, props));

Strip.defaultProps = {
  position: 'absolute',
  size: 5
};
 false ? 0 : void 0;
/* harmony default export */ var strip = (/*#__PURE__*/(0,react.memo)(Strip));
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Strip/index.js


/***/ }),

/***/ 63825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Text_text; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/text.styles.js



const Container = styled_components_browser_esm/* default.p.attrs */.ZP.p.attrs(props => ({
  color: props.color ? (0,esm/* getTextColor */.uu)(props.color)(props) || props.color : (0,esm/* getTextColor */.uu)('base')(props)
}))`
  ${(0,index_esm/* compose */.qC)(index_esm/* typography */.cp, index_esm/* space */.Dh, esm/* color */.$_, index_esm/* layout */.bK, index_esm/* position */.FK, index_esm/* flexbox */.GQ, esm/* gap */.SG)}
  ${(0,index_esm/* system */.By)({
  transform: true
})}
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/text.js





/**
 * A low-level component for setting font-size, typographic styles, margin, and color.
 */

const Text = /*#__PURE__*/react.forwardRef((_ref, ref) => {
  let {
    children
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["children"]);

  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    ref: ref
  }, props), children);
});
Text.propTypes = {
  children: (0,prop_types.oneOfType)([prop_types.string, prop_types.node, (0,prop_types.arrayOf)(prop_types.element)])
};
Text.defaultProps = {
  children: ''
};
Text.displayName = 'Text';
/* harmony default export */ var Text_text = (Text);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js


/***/ }),

/***/ 87043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "UQ": function() { return /* reexport */ Accordion/* default */.Z; },
  "Yd": function() { return /* reexport */ BaseButton/* default */.Z; },
  "xu": function() { return /* reexport */ Box/* default */.Z; },
  "gN": function() { return /* reexport */ breadcrumb_item; },
  "zx": function() { return /* reexport */ Button/* default */.Z; },
  "XZ": function() { return /* reexport */ Checkbox/* default */.Z; },
  "Af": function() { return /* reexport */ Chip/* default */.Z; },
  "Vq": function() { return /* reexport */ Dialog/* default */.Z; },
  "Lt": function() { return /* reexport */ Dropdown/* default */.Z; },
  "cx": function() { return /* reexport */ Embed_Embed; },
  "kC": function() { return /* reexport */ Flex/* default */.Z; },
  "rj": function() { return /* reexport */ Grid/* default */.Z; },
  "X6": function() { return /* reexport */ Heading/* default */.Z; },
  "bo": function() { return /* reexport */ HorizontalRule/* default */.Z; },
  "Ee": function() { return /* reexport */ ResponsiveImage/* default */.Z; },
  "II": function() { return /* reexport */ Input/* default */.Z; },
  "ck": function() { return /* reexport */ Item/* default */.Z; },
  "uk": function() { return /* reexport */ linear_progress; },
  "rU": function() { return /* reexport */ atoms_Link/* default */.Z; },
  "TR": function() { return /* reexport */ Logo/* default */.Z; },
  "fG": function() { return /* reexport */ NumberedButton/* default */.Z; },
  "SX": function() { return /* reexport */ PageLoading/* default */.Z; },
  "rD": function() { return /* reexport */ Popper/* default */.Z; },
  "U2": function() { return /* reexport */ range_slider; },
  "Ph": function() { return /* reexport */ Select/* default */.Z; },
  "jv": function() { return /* reexport */ SelectRating/* default */.Z; },
  "D_": function() { return /* reexport */ Strip/* default */.Z; },
  "OK": function() { return /* reexport */ tab; },
  "q5": function() { return /* reexport */ tab_context; },
  "td": function() { return /* reexport */ tab_list; },
  "x4": function() { return /* reexport */ tab_panel; },
  "xv": function() { return /* reexport */ atoms_Text/* default */.Z; }
});

// UNUSED EXPORTS: Card, Collapse, ConfirmButton, Favicon, HotLink, JSONLD, LazyLoadComponent, LogoParceiroMagalu, MenuItem, Portal, Radio, breadcrumbSchema, productSchema

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Accordion/index.js + 2 modules
var Accordion = __webpack_require__(50616);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/BaseButton/index.js + 1 modules
var BaseButton = __webpack_require__(66685);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/BreadcrumbItem/breadcrumb-item.styles.js




const SellerItem = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
  padding: ${props => (0,esm/* themeGet */.R)('space.2')(props)}px 0;
`;
const SellerText = styled_components_browser_esm/* default.span */.ZP.span`
  font-size: ${props => (0,esm/* themeGet */.R)('fontSizes.0')(props)}px;
  color: ${props => (0,esm/* getTextColor */.uu)('light')(props)};
`;
const SellerName = styled_components_browser_esm/* default.span */.ZP.span`
  font-size: ${props => (0,esm/* themeGet */.R)('fontSizes.2')(props)}px;
  color: ${props => (0,esm/* getTextColor */.uu)('base')(props)};
`;
const ListItem = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z)`
  align-items: center;
  height: 100%;
`;
const ChevronRightIcon = (0,styled_components_browser_esm/* default */.ZP)(build_esm/* ChevronRight */._Qn).attrs(props => ({
  color: (0,esm/* getTextColor */.uu)('lighter')(props)
}))``;
const Link = styled_components_browser_esm/* default.a */.ZP.a`
  text-decoration: none;
  font-size: ${props => (0,esm/* themeGet */.R)('fontSizes.1')(props)}px;
  color: ${props => (0,esm/* getTextColor */.uu)('lighter')(props)};
`;
const Text = styled_components_browser_esm/* default.span */.ZP.span`
  font-size: ${props => (0,esm/* themeGet */.R)('fontSizes.1')(props)}px;
  color: ${props => (0,esm/* getTextColor */.uu)('scratched')(props)};
`;
const Name = styled_components_browser_esm/* default.span */.ZP.span`
  display: flex;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/BreadcrumbItem/breadcrumb-item.js






const BreadcrumbItem = _ref => {
  let {
    seller,
    item,
    onClick,
    active
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["seller", "item", "onClick", "active"]);

  const Description = active ? Text : Link;

  if (seller) {
    return /*#__PURE__*/react.createElement(ListItem, {
      "data-testid": "breadcrumb-item-list"
    }, /*#__PURE__*/react.createElement(SellerItem, {
      "data-testid": "breadcrumb-item"
    }, /*#__PURE__*/react.createElement(SellerText, null, seller.text), /*#__PURE__*/react.createElement(SellerName, {
      "data-testid": "breadcrumb-item-name"
    }, /*#__PURE__*/react.createElement("b", null, seller.name))));
  }

  return /*#__PURE__*/react.createElement(ListItem, {
    "data-testid": "breadcrumb-item-list"
  }, item.position > 0 && /*#__PURE__*/react.createElement(ChevronRightIcon, {
    width: 20,
    height: 20
  }), /*#__PURE__*/react.createElement(Description, (0,esm_extends/* default */.Z)({
    "data-testid": "breadcrumb-item",
    onClick: !active ? e => onClick(e, item) : null,
    active: active,
    href: item.url
  }, props), /*#__PURE__*/react.createElement(Name, null, item.icon || item.name)));
};

BreadcrumbItem.defaultProps = {
  seller: undefined,
  item: undefined,
  active: true,
  onClick: () => {}
};
 false ? 0 : void 0;
/* harmony default export */ var breadcrumb_item = (BreadcrumbItem);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/BreadcrumbItem/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Card/index.js + 2 modules
var Card = __webpack_require__(27439);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Checkbox/index.js + 2 modules
var Checkbox = __webpack_require__(18281);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Chip/index.js + 2 modules
var Chip = __webpack_require__(17781);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Collapse/index.js + 2 modules
var Collapse = __webpack_require__(88699);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dialog/index.js + 1 modules
var Dialog = __webpack_require__(66762);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dropdown/index.js + 7 modules
var Dropdown = __webpack_require__(74822);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Embed/styled.js

const Container = styled_components_browser_esm/* default.div */.ZP.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: ${({
  padding
}) => padding}%;
`;
const Iframe = styled_components_browser_esm/* default.iframe */.ZP.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
`;
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/utils/index.js + 18 modules
var utils = __webpack_require__(86349);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Embed/Embed.js







const Embed = _ref => {
  let {
    src,
    ratio
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["src", "ratio"]);

  const [width, height] = (ratio && typeof ratio === 'string' ? ratio : '16:9').split(':');
  const aspecRatio = width && height ? height / width : null;
  const padding = aspecRatio && !Number.isNaN(aspecRatio) ? (aspecRatio * 100).toFixed(2) : '56.25';
  return /*#__PURE__*/react.createElement(Container, (0,esm_extends/* default */.Z)({
    "data-testid": "embed",
    padding: padding
  }, props), /*#__PURE__*/react.createElement(Iframe, {
    src: (0,utils/* embedYoutubeUrl */.qJ)(src)
  }));
};

 false ? 0 : void 0;
Embed.defaultProps = {
  ratio: '16:9'
};
/* harmony default export */ var Embed_Embed = (Embed);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Embed/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ConfirmButton/index.js + 1 modules
var ConfirmButton = __webpack_require__(58331);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Grid/index.js + 2 modules
var Grid = __webpack_require__(8341);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/HorizontalRule/index.js + 2 modules
var HorizontalRule = __webpack_require__(97600);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/HotLink/index.js + 2 modules
var HotLink = __webpack_require__(39471);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Input/index.js + 2 modules
var Input = __webpack_require__(29869);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Item/index.js + 5 modules
var Item = __webpack_require__(81572);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/JsonLD/index.js + 1 modules
var JsonLD = __webpack_require__(66228);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/JsonLD/schemas/index.js + 11 modules
var schemas = __webpack_require__(93088);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/LazyLoadComponent/index.js + 1 modules
var LazyLoadComponent = __webpack_require__(91785);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/LinearProgress/linear-progress.styles.js



const getBulletStyle = ({
  quantity = 0,
  size = 6,
  color = 'rgba(0, 0, 0, 0.3)'
}) => styled_components_browser_esm/* css */.iv`
  width: ${size}px;
  height: ${size}px;
  background-color: ${color};
  border-radius: 50%;
  margin-right: calc((100% / ${quantity}) - ${size}px);

  &:last-child {
    margin-right: ${size}px;
  }
`;

const Bullets = styled_components_browser_esm/* default.div */.ZP.div`
  position: relative;
  height: ${({
  height
}) => height};

  display: flex;
  justify-content: flex-end;
  align-items: center;

  div {
    ${({
  bullets
}) => getBulletStyle(bullets)}
  }
`;
const linear_progress_styles_Container = styled_components_browser_esm/* default.div */.ZP.div`
  position: relative;
  width: ${({
  width
}) => width || `100%`};
  height: ${({
  height
}) => height || `auto`};
`;
const Progress = styled_components_browser_esm/* default.progress */.ZP.progress`
  position: absolute;
  width: ${({
  width
}) => width || `100%`};
  height: ${({
  height
}) => height || `auto`};
  border-radius: ${(0,esm/* themeGet */.R)('radii.big')};
  appearance: none;
  border: none;

  &::-webkit-progress-bar {
    height: ${({
  height
}) => height};
    border-radius: ${(0,esm/* themeGet */.R)('radii.big')};
    background-color: ${props => (0,esm/* getBackgroundColor */.dF)('whisper')(props)};
  }

  &::-webkit-progress-value {
    height: ${({
  height
}) => height};
    border-radius: ${(0,esm/* themeGet */.R)('radii.big')};
    background-color: ${({
  color
}) => color};
  }

  &::-moz-progress-bar {
    height: ${({
  height
}) => height};
    border-radius: ${(0,esm/* themeGet */.R)('radii.big')};
    background-color: ${({
  color
}) => color};
  }
`;
const Label = styled_components_browser_esm/* default.span */.ZP.span`
  font-size: ${props => (0,esm/* themeGet */.R)('fontSizes.3')(props)}px;
  color: ${({
  color
}) => (0,esm/* darken */._j)(color, 15)};
  font-weight: ${props => (0,esm/* themeGet */.R)('fontWeights.bold')(props)};

  position: absolute;
  left: ${({
  value
}) => value && `calc(${value}% - 22px)`};
  top: -25px;
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/LinearProgress/linear-progress.js




const getBullets = ({
  quantity
}) => quantity && Array.from(Array(quantity).keys()).map(key => /*#__PURE__*/react.createElement("div", {
  key: key,
  "data-testid": "linear-progress-bullet"
}));

const hasBullets = bullets => Boolean(Object.keys(bullets).length);

const LinearProgress = ({
  bullets,
  value,
  max,
  color,
  label,
  height,
  width
} = {}) => {
  return /*#__PURE__*/react.createElement(linear_progress_styles_Container, {
    color: color,
    width: width,
    height: height,
    "data-testid": "linear-progress"
  }, label && /*#__PURE__*/react.createElement(Label, {
    color: color,
    value: value,
    "data-testid": "linear-progress-label"
  }, label), /*#__PURE__*/react.createElement(Progress, {
    max: max,
    color: color,
    width: width,
    height: height,
    value: value,
    "data-label": label
  }, label), hasBullets(bullets) && /*#__PURE__*/react.createElement(Bullets, {
    bullets: bullets,
    height: height
  }, getBullets(bullets)));
};

 false ? 0 : void 0;
LinearProgress.defaultProps = {
  max: 100,
  label: '',
  color: '#FFCC03',
  width: '100%',
  height: '10px',
  bullets: {}
};
/* harmony default export */ var linear_progress = (LinearProgress);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/LinearProgress/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Logo/index.js + 1 modules
var Logo = __webpack_require__(15566);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/LogoParceiroMagalu/index.js + 2 modules
var LogoParceiroMagalu = __webpack_require__(23076);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/MenuItem/index.js + 2 modules
var MenuItem = __webpack_require__(54934);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Select/index.js + 2 modules
var Select = __webpack_require__(73002);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Favicon/favicon.js




function Favicon({
  links
}) {
  return links.map((linkProps, key) => /*#__PURE__*/react.createElement("link", (0,esm_extends/* default */.Z)({
    key: `link-head-${key}`
  }, linkProps)));
}

Favicon.defaultProps = {
  links: []
};
 false ? 0 : void 0;
/* harmony default export */ var favicon = ((/* unused pure expression or super */ null && (Favicon)));
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Favicon/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/NumberedButton/index.js + 2 modules
var NumberedButton = __webpack_require__(97851);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var atoms_Link = __webpack_require__(10200);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/PageLoading/index.js + 2 modules
var PageLoading = __webpack_require__(26527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Portal/index.js + 1 modules
var Portal = __webpack_require__(75851);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Radio/index.js + 2 modules
var Radio = __webpack_require__(70715);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Strip/index.js + 2 modules
var Strip = __webpack_require__(85737);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Tab/tab.js



const Tab = /*#__PURE__*/(0,react.forwardRef)(function Tab(_ref, ref) {
  let {
    onChange,
    onClick,
    value,
    children: childrenProp
  } = _ref,
      other = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["onChange", "onClick", "value", "children"]);

  const handleClick = event => {
    onChange(event, value);
    onClick(event);
  };

  if (! /*#__PURE__*/react.isValidElement(childrenProp)) return null;
  const children = /*#__PURE__*/react.cloneElement(childrenProp, Object.assign({}, other));
  return /*#__PURE__*/react.createElement("div", {
    onClick: handleClick,
    ref: ref
  }, children);
});
Tab.defaultProps = {
  onClick: () => ({})
};
 false ? 0 : void 0;
/* harmony default export */ var tab = (Tab);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Tab/index.js

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/TabContext/tab-context.js


const Context = /*#__PURE__*/(0,react.createContext)(null);
Context.displayName = 'TabContext';

const useUniquePrefix = () => {
  const [id, setId] = react.useState(null);
  react.useEffect(() => {
    setId(`stereo-id-${Math.round(Math.random() * 1e5)}`);
  }, []);
  return id;
};

const TabContext = ({
  children,
  value
}) => {
  const idPrefix = useUniquePrefix();
  const context = (0,react.useMemo)(() => {
    return {
      idPrefix,
      value
    };
  }, [value]);
  return /*#__PURE__*/react.createElement(Context.Provider, {
    value: context
  }, children);
};

const useTabContext = () => (0,react.useContext)(Context);
const getPanelId = (context, value) => {
  const {
    idPrefix
  } = context;

  if (idPrefix === null) {
    return null;
  }

  return `${context.idPrefix}-P-${value}`;
};
const getTabId = (context, value) => {
  const {
    idPrefix
  } = context;

  if (idPrefix === null) {
    return null;
  }

  return `${context.idPrefix}-T-${value}`;
};
 false ? 0 : void 0;
/* harmony default export */ var tab_context = (TabContext);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/TabContext/index.js


;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Tabs/tabs.js




const Tabs = /*#__PURE__*/react.forwardRef(function Tabs(props, ref) {
  const {
    onChange,
    value,
    children: childrenProp
  } = props,
        others = (0,objectWithoutPropertiesLoose/* default */.Z)(props, ["onChange", "value", "children"]);

  const children = react.Children.map(childrenProp, child => {
    const childValue = child.props.value;
    if (childValue === undefined) return null;
    const selected = childValue === value;
    return /*#__PURE__*/react.cloneElement(child, {
      value: childValue,
      onChange,
      selected
    });
  });
  return /*#__PURE__*/react.createElement("div", (0,esm_extends/* default */.Z)({}, others, {
    ref: ref,
    role: "tablist"
  }), children);
});
 false ? 0 : void 0;
/* harmony default export */ var tabs = (Tabs);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Tabs/index.js

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/TabList/tab-list.js






const TabList = /*#__PURE__*/react.forwardRef(function TabList(props, ref) {
  const {
    children: childrenProp
  } = props,
        other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, ["children"]);

  const context = useTabContext();

  if (context === null) {
    throw new TypeError('No TabContext provided');
  }

  const children = react.Children.map(childrenProp, child => {
    if (! /*#__PURE__*/react.isValidElement(child)) return null;
    return /*#__PURE__*/react.cloneElement(child, {
      'aria-controls': getPanelId(context, child.props.value),
      id: getTabId(context, child.props.value)
    });
  });
  return /*#__PURE__*/react.createElement(tabs, (0,esm_extends/* default */.Z)({}, other, {
    ref: ref,
    value: context.value
  }), children);
});
 false ? 0 : void 0;
/* harmony default export */ var tab_list = (TabList);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/TabList/index.js

;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/TabPanel/tab-panel.js






const TabPanel = /*#__PURE__*/react.forwardRef(function TabPanel(_ref, ref) {
  let {
    children,
    value
  } = _ref,
      other = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["children", "value"]);

  const context = useTabContext();

  if (context === null) {
    throw new TypeError('No TabContext provided');
  }

  const id = getPanelId(context, value);
  const tabId = getTabId(context, value);
  if (value === undefined) return null;
  return /*#__PURE__*/react.createElement(Box/* default */.Z, (0,esm_extends/* default */.Z)({
    ref: ref,
    hidden: context.value !== value,
    id: id,
    "aria-labelledby": tabId,
    role: "tabpanel"
  }, other), children);
});
 false ? 0 : void 0;
/* harmony default export */ var tab_panel = (TabPanel);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/TabPanel/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var atoms_Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/SelectRating/index.js + 2 modules
var SelectRating = __webpack_require__(76328);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/RangeSlider/range-slider.styles.js




const range_slider_styles_Container = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'background.lighter'
})`
  height: 24px;
`;
const SliderField = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z)`
  width: 100%;
`;
const SliderTrack = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(props => Object.assign({}, props, {
  borderRadius: 'medium',
  zIndex: 0
}))`
  background-color: ${props => (0,esm/* themeGet */.R)('baseColors.wildsand.base')(props)};
  position: absolute;
  height: 3px;
  width: 100%;
`;
const SliderRange = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs({
  bg: 'background.primary',
  borderRadius: 'medium',
  zIndex: 1
})`
  position: absolute;
  height: 3px;
`;
const SliderInput = styled_components_browser_esm/* default.input.attrs */.ZP.input.attrs({
  type: 'range'
})`
  pointer-events: none;
  position: absolute;
  height: 0;
  width: 100%;
  outline: none;
  z-index: ${props => props.overlapIndex ? (0,esm/* themeGet */.R)(`zIndices.${props.overlapIndex}`)(props) : (0,esm/* themeGet */.R)('zIndices.3')(props)};

  &,
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    -webkit-tap-highlight-color: transparent;
  }

  &::-webkit-slider-thumb {
    background-color: ${(0,esm/* getBackgroundColor */.dF)('lighter')};
    border: ${props => (0,esm/* themeGet */.R)('borders.0')(props)};
    border-radius: ${props => (0,esm/* themeGet */.R)('radii.circle')(props)};
    box-shadow: ${props => (0,esm/* themeGet */.R)('boxShadows.2')(props)};
    cursor: pointer;
    height: 24px;
    width: 24px;
    margin-top: 4px;
    pointer-events: all;
    position: relative;
  }

  &::-moz-range-thumb {
    background-color: ${(0,esm/* getBackgroundColor */.dF)('lighter')};
    border: ${props => (0,esm/* themeGet */.R)('borders.0')(props)};
    border-radius: ${props => (0,esm/* themeGet */.R)('radii.circle')(props)};
    box-shadow: ${props => (0,esm/* themeGet */.R)('boxShadows.2')(props)};
    cursor: pointer;
    height: 24px;
    width: 24px;
    margin-top: 4px;
    pointer-events: all;
    position: relative;
  }
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/RangeSlider/range-slider.js





const RangeSlider = ({
  minAllowed,
  maxAllowed,
  currentMin,
  currentMax,
  onChange
}) => {
  const [minVal, setMinVal] = (0,react.useState)(currentMin);
  const [maxVal, setMaxVal] = (0,react.useState)(currentMax);
  const minValRef = (0,react.useRef)(null);
  const maxValRef = (0,react.useRef)(null);
  const range = (0,react.useRef)(null);
  const getPercent = (0,react.useCallback)(value => Math.round((value - minAllowed) / (maxAllowed - minAllowed) * 100), [currentMin, currentMax]);

  const isValidMin = value => (0,utils/* isMinValidValue */.Z4)(value, currentMax, minAllowed, maxAllowed);

  const isValidMax = value => (0,utils/* isMaxValidValue */.rx)(value, currentMin, minAllowed, maxAllowed);

  (0,react.useEffect)(() => {
    if (maxValRef.current) {
      const minPercent = getPercent(minVal);
      const maxPercent = getPercent(+maxValRef.current.value);

      if (range.current) {
        range.current.style.left = `${minPercent}%`;
        range.current.style.width = `${maxPercent - minPercent}%`;
      }
    }
  }, [minVal, getPercent]);
  (0,react.useEffect)(() => {
    if (minValRef.current) {
      const minPercent = getPercent(+minValRef.current.value);
      const maxPercent = getPercent(maxVal);

      if (range.current) {
        range.current.style.width = `${maxPercent - minPercent}%`;
      }
    }
  }, [maxVal, getPercent]);
  (0,react.useEffect)(() => {
    setMinVal(isValidMin(currentMin) ? currentMin : minAllowed);
    setMaxVal(isValidMax(currentMax) ? currentMax : maxAllowed);
  }, [currentMin, currentMax]);

  const handleUpdate = (newMin, newMax) => {
    onChange({
      currentMin: newMin,
      currentMax: newMax
    });
  };

  function handleMinChange(event) {
    const value = Math.min(+event.target.value, maxVal - 1);
    setMinVal(value);
    handleUpdate(value, maxVal);
  }

  function handleMaxChange(event) {
    const value = Math.max(+event.target.value, minVal + 1);
    setMaxVal(value);
    handleUpdate(minVal, value);
  }

  return /*#__PURE__*/react.createElement(range_slider_styles_Container, null, /*#__PURE__*/react.createElement(SliderInput, {
    "data-testid": "slider-input-min",
    type: "range",
    min: minAllowed,
    max: maxAllowed,
    value: minVal,
    ref: minValRef,
    step: 0.01,
    overlapIndex: minVal > maxAllowed - 100 ? 4 : 2,
    onChange: handleMinChange
  }), /*#__PURE__*/react.createElement(SliderInput, {
    "data-testid": "slider-input-max",
    type: "range",
    min: minAllowed,
    max: maxAllowed,
    value: maxVal,
    ref: maxValRef,
    step: 0.01,
    onChange: handleMaxChange
  }), /*#__PURE__*/react.createElement(SliderField, null, /*#__PURE__*/react.createElement(SliderTrack, null), /*#__PURE__*/react.createElement(SliderRange, {
    ref: range
  })));
};

 false ? 0 : void 0;
/* harmony default export */ var range_slider = (RangeSlider);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/RangeSlider/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Popper/index.js + 2 modules
var Popper = __webpack_require__(7121);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js














































/***/ }),

/***/ 12468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bl": function() { return /* binding */ ICON_SHOW_FULL_LIST; },
/* harmony export */   "Co": function() { return /* binding */ MINIATURE; },
/* harmony export */   "IY": function() { return /* binding */ LIST; },
/* harmony export */   "K9": function() { return /* binding */ LABEL_SHOW_MORE; },
/* harmony export */   "RW": function() { return /* binding */ MAGALU_DOMAIN; },
/* harmony export */   "Uh": function() { return /* binding */ ICON_SHOW_MORE; },
/* harmony export */   "dz": function() { return /* binding */ LABEL_SHOW_FULL_LIST; },
/* harmony export */   "ig": function() { return /* binding */ DEFAULT_SELLER; },
/* harmony export */   "w": function() { return /* binding */ productImageSizes; },
/* harmony export */   "wp": function() { return /* binding */ NATIONAL_CURRENCY; },
/* harmony export */   "yg": function() { return /* binding */ GALLERY; }
/* harmony export */ });
/* unused harmony exports displayEnum, INTEREST_FREE_LABEL */
const MINIATURE = `miniature`;
const GALLERY = `gallery`;
const LIST = `list`;
const displayEnum = {
  miniature: 'Miniatura',
  list: 'Lista',
  gallery: 'Galeria'
};
const INTEREST_FREE_LABEL = 'sem juros';
const MAGALU_DOMAIN = 'https://www.magazineluiza.com.br';
const productImageSizes = {
  width: '186',
  height: '140'
};
const DEFAULT_SELLER = 'magazineluiza';
const LABEL_SHOW_FULL_LIST = 'Descubra outras ofertas aqui';
const ICON_SHOW_FULL_LIST = {
  endIcon: 'ChevronRight',
  justifyContent: 'flex-start'
};
const LABEL_SHOW_MORE = 'Mostrar mais produtos';
const ICON_SHOW_MORE = {
  startIcon: 'ChevronDownCircle',
  centered: true
};
const NATIONAL_CURRENCY = 'BRL';

/***/ }),

/***/ 87302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CKO": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_4__.CK; },
/* harmony export */   "Eep": function() { return /* reexport safe */ _atoms__WEBPACK_IMPORTED_MODULE_0__.Ee; },
/* harmony export */   "VqE": function() { return /* reexport safe */ _atoms__WEBPACK_IMPORTED_MODULE_0__.Vq; },
/* harmony export */   "X6q": function() { return /* reexport safe */ _atoms__WEBPACK_IMPORTED_MODULE_0__.X6; },
/* harmony export */   "YE2": function() { return /* reexport safe */ _organisms__WEBPACK_IMPORTED_MODULE_2__.YE; },
/* harmony export */   "bdZ": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_4__.bd; },
/* harmony export */   "kCb": function() { return /* reexport safe */ _atoms__WEBPACK_IMPORTED_MODULE_0__.kC; },
/* harmony export */   "lbA": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_4__.lb; },
/* harmony export */   "rUS": function() { return /* reexport safe */ _atoms__WEBPACK_IMPORTED_MODULE_0__.rU; },
/* harmony export */   "rjZ": function() { return /* reexport safe */ _atoms__WEBPACK_IMPORTED_MODULE_0__.rj; },
/* harmony export */   "t$X": function() { return /* reexport safe */ _utils__WEBPACK_IMPORTED_MODULE_4__.t$; },
/* harmony export */   "ukE": function() { return /* reexport safe */ _atoms__WEBPACK_IMPORTED_MODULE_0__.uk; },
/* harmony export */   "xuv": function() { return /* reexport safe */ _atoms__WEBPACK_IMPORTED_MODULE_0__.xu; },
/* harmony export */   "xvT": function() { return /* reexport safe */ _atoms__WEBPACK_IMPORTED_MODULE_0__.xv; }
/* harmony export */ });
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87043);
/* harmony import */ var _molecules__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90749);
/* harmony import */ var _organisms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25164);
/* harmony import */ var _templates__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82709);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86349);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12468);







/***/ })

}]);